/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.2.5.0 (NJsonSchema v10.1.7.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(<any>response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>_observableThrow(response_);
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendHelpDeskEmail(body: HelpDeskEmailRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendHelpDeskEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendHelpDeskEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendHelpDeskEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendHelpDeskEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    captcha(body: CaptchaModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Captcha";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCaptcha(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCaptcha(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCaptcha(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CertificationAnswerServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CAnswerCreateInput | undefined): Observable<CAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/CertificationAnswerService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CAnswerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CAnswerDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CAnswerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CAnswerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CAnswerDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CertificationAnswerService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/CertificationAnswerService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CAnswerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CAnswerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CAnswerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CAnswerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CAnswerDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CAnswerUpdateInput | undefined): Observable<CAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/CertificationAnswerService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CAnswerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CAnswerDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CAnswerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CAnswerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CAnswerDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    save(body: CAnswerDto | undefined): Observable<CAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/CertificationAnswerService/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(<any>response_);
                } catch (e) {
                    return <Observable<CAnswerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CAnswerDto>><any>_observableThrow(response_);
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<CAnswerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CAnswerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CAnswerDto>(<any>null);
    }

    /**
     * @param certificationId (optional) 
     * @return Success
     */
    getAll(certificationId: number | undefined): Observable<CAnswerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CertificationAnswerService/GetAll?";
        if (certificationId === null)
            throw new Error("The parameter 'certificationId' cannot be null.");
        else if (certificationId !== undefined)
            url_ += "CertificationId=" + encodeURIComponent("" + certificationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CAnswerDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CAnswerDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CAnswerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CAnswerDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CAnswerDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class CertificationCategoryServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param certificationId (optional) 
     * @return Success
     */
    getCategories(certificationId: number | null | undefined): Observable<CCategoryAnswerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CertificationCategoryService/GetCategories?";
        if (certificationId !== undefined)
            url_ += "certificationId=" + encodeURIComponent("" + certificationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategories(<any>response_);
                } catch (e) {
                    return <Observable<CCategoryAnswerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CCategoryAnswerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategories(response: HttpResponseBase): Observable<CCategoryAnswerDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CCategoryAnswerDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CCategoryAnswerDto[]>(<any>null);
    }
}

@Injectable()
export class CertificationCategorySummaryServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param certificationId (optional) 
     * @return Success
     */
    getAllByCertificationId(certificationId: number | undefined): Observable<CCertificationCategorySummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CertificationCategorySummaryService/GetAllByCertificationId?";
        if (certificationId === null)
            throw new Error("The parameter 'certificationId' cannot be null.");
        else if (certificationId !== undefined)
            url_ += "certificationId=" + encodeURIComponent("" + certificationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByCertificationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByCertificationId(<any>response_);
                } catch (e) {
                    return <Observable<CCertificationCategorySummaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CCertificationCategorySummaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByCertificationId(response: HttpResponseBase): Observable<CCertificationCategorySummaryDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CCertificationCategorySummaryDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CCertificationCategorySummaryDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    updateAllCertificationCategorySummaries(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CertificationCategorySummaryService/UpdateAllCertificationCategorySummaries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllCertificationCategorySummaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllCertificationCategorySummaries(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAllCertificationCategorySummaries(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CertificationServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CCertificationCreateInput | undefined): Observable<CCertificationDto> {
        let url_ = this.baseUrl + "/api/services/app/CertificationService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CCertificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CCertificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CCertificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CCertificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CCertificationDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CCertificationUpdateInput | undefined): Observable<CCertificationDto> {
        let url_ = this.baseUrl + "/api/services/app/CertificationService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CCertificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CCertificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CCertificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CCertificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CCertificationDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CCertificationDto> {
        let url_ = this.baseUrl + "/api/services/app/CertificationService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CCertificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CCertificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CCertificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CCertificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CCertificationDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CertificationService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param isActive (optional) 
     * @param farmerId (optional) 
     * @return Success
     */
    getAll(isActive: boolean | null | undefined, farmerId: number | null | undefined): Observable<CCertificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CertificationService/GetAll?";
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (farmerId !== undefined)
            url_ += "FarmerId=" + encodeURIComponent("" + farmerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CCertificationDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CCertificationDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CCertificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CCertificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CCertificationDtoPagedResultDto>(<any>null);
    }

    /**
     * @param certificationId (optional) 
     * @return Success
     */
    getCertificationScores(certificationId: number | undefined): Observable<CertificationScore> {
        let url_ = this.baseUrl + "/api/services/app/CertificationService/GetCertificationScores?";
        if (certificationId === null)
            throw new Error("The parameter 'certificationId' cannot be null.");
        else if (certificationId !== undefined)
            url_ += "certificationId=" + encodeURIComponent("" + certificationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificationScores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificationScores(<any>response_);
                } catch (e) {
                    return <Observable<CertificationScore>><any>_observableThrow(e);
                }
            } else
                return <Observable<CertificationScore>><any>_observableThrow(response_);
        }));
    }

    protected processGetCertificationScores(response: HttpResponseBase): Observable<CertificationScore> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificationScore.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificationScore>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    save(body: CCertificationDto | undefined): Observable<CCertificationDto> {
        let url_ = this.baseUrl + "/api/services/app/CertificationService/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(<any>response_);
                } catch (e) {
                    return <Observable<CCertificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CCertificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<CCertificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CCertificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CCertificationDto>(<any>null);
    }

    /**
     * @param farmerId (optional) 
     * @return Success
     */
    updateCertificationScores(farmerId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CertificationService/UpdateCertificationScores?";
        if (farmerId !== undefined)
            url_ += "farmerId=" + encodeURIComponent("" + farmerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCertificationScores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCertificationScores(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCertificationScores(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CostShareServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<CostShareDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CostShareService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CostShareDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CostShareDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CostShareDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CostShareDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CostShareDto[]>(<any>null);
    }
}

@Injectable()
export class CountyServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<CountyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CountyService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CountyDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountyDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CountyDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CountyDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountyDto[]>(<any>null);
    }
}

@Injectable()
export class CropServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<CropDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CropService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CropDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CropDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CropDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CropDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CropDto[]>(<any>null);
    }
}

@Injectable()
export class DashboardServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getFarmerRegistration(): Observable<FarmerRegistrationCompleteDto> {
        let url_ = this.baseUrl + "/api/services/app/DashboardService/GetFarmerRegistration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFarmerRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFarmerRegistration(<any>response_);
                } catch (e) {
                    return <Observable<FarmerRegistrationCompleteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerRegistrationCompleteDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFarmerRegistration(response: HttpResponseBase): Observable<FarmerRegistrationCompleteDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FarmerRegistrationCompleteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerRegistrationCompleteDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCertificationScore(): Observable<CertificationScoreDto> {
        let url_ = this.baseUrl + "/api/services/app/DashboardService/GetCertificationScore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificationScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificationScore(<any>response_);
                } catch (e) {
                    return <Observable<CertificationScoreDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CertificationScoreDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCertificationScore(response: HttpResponseBase): Observable<CertificationScoreDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificationScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificationScoreDto>(<any>null);
    }

    /**
     * @return Success
     */
    export(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/DashboardService/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

@Injectable()
export class ExportServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: ExportRequestDto | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/ExportService/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

@Injectable()
export class FarmerCostShareServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param farmerId (optional) 
     * @return Success
     */
    getAllByFarmerId(farmerId: number | undefined): Observable<FarmerCostShareDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FarmerCostShareService/GetAllByFarmerId?";
        if (farmerId === null)
            throw new Error("The parameter 'farmerId' cannot be null.");
        else if (farmerId !== undefined)
            url_ += "farmerId=" + encodeURIComponent("" + farmerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByFarmerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByFarmerId(<any>response_);
                } catch (e) {
                    return <Observable<FarmerCostShareDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerCostShareDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByFarmerId(response: HttpResponseBase): Observable<FarmerCostShareDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FarmerCostShareDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerCostShareDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAll(body: FarmerCostShare[] | null | undefined): Observable<FarmerCostShareDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FarmerCostShareService/CreateOrUpdateAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAll(<any>response_);
                } catch (e) {
                    return <Observable<FarmerCostShareDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerCostShareDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateAll(response: HttpResponseBase): Observable<FarmerCostShareDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FarmerCostShareDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerCostShareDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FarmerCostShareService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FarmerCountyServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param farmerId (optional) 
     * @return Success
     */
    getAllByFarmerId(farmerId: number | undefined): Observable<FarmerCountyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FarmerCountyService/GetAllByFarmerId?";
        if (farmerId === null)
            throw new Error("The parameter 'farmerId' cannot be null.");
        else if (farmerId !== undefined)
            url_ += "farmerId=" + encodeURIComponent("" + farmerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByFarmerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByFarmerId(<any>response_);
                } catch (e) {
                    return <Observable<FarmerCountyDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerCountyDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByFarmerId(response: HttpResponseBase): Observable<FarmerCountyDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FarmerCountyDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerCountyDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAll(body: FarmerCounty[] | null | undefined): Observable<FarmerCountyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FarmerCountyService/CreateOrUpdateAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAll(<any>response_);
                } catch (e) {
                    return <Observable<FarmerCountyDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerCountyDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateAll(response: HttpResponseBase): Observable<FarmerCountyDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FarmerCountyDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerCountyDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FarmerCountyService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FarmerCropQuantityServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param farmerId (optional) 
     * @return Success
     */
    getAllByFarmerId(farmerId: number | undefined): Observable<FarmerCropQuantityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FarmerCropQuantityService/GetAllByFarmerId?";
        if (farmerId === null)
            throw new Error("The parameter 'farmerId' cannot be null.");
        else if (farmerId !== undefined)
            url_ += "farmerId=" + encodeURIComponent("" + farmerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByFarmerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByFarmerId(<any>response_);
                } catch (e) {
                    return <Observable<FarmerCropQuantityDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerCropQuantityDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByFarmerId(response: HttpResponseBase): Observable<FarmerCropQuantityDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FarmerCropQuantityDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerCropQuantityDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAll(body: FarmerCropQuantity[] | null | undefined): Observable<FarmerCropQuantityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FarmerCropQuantityService/CreateOrUpdateAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAll(<any>response_);
                } catch (e) {
                    return <Observable<FarmerCropQuantityDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerCropQuantityDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateAll(response: HttpResponseBase): Observable<FarmerCropQuantityDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FarmerCropQuantityDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerCropQuantityDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FarmerCropQuantityService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FarmerManureStorageServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param farmerId (optional) 
     * @return Success
     */
    getAllByFarmerId(farmerId: number | undefined): Observable<FarmerManureStorageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FarmerManureStorageService/GetAllByFarmerId?";
        if (farmerId === null)
            throw new Error("The parameter 'farmerId' cannot be null.");
        else if (farmerId !== undefined)
            url_ += "farmerId=" + encodeURIComponent("" + farmerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByFarmerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByFarmerId(<any>response_);
                } catch (e) {
                    return <Observable<FarmerManureStorageDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerManureStorageDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByFarmerId(response: HttpResponseBase): Observable<FarmerManureStorageDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FarmerManureStorageDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerManureStorageDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: FarmerManureStorage | undefined): Observable<FarmerManureStorageDto> {
        let url_ = this.baseUrl + "/api/services/app/FarmerManureStorageService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FarmerManureStorageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerManureStorageDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FarmerManureStorageDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FarmerManureStorageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerManureStorageDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FarmerManureStorageService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FarmerNutrientRecommendationQuantityServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param farmerId (optional) 
     * @return Success
     */
    getAllByFarmerId(farmerId: number | undefined): Observable<FarmerNutrientRecommendationQuantityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FarmerNutrientRecommendationQuantityService/GetAllByFarmerId?";
        if (farmerId === null)
            throw new Error("The parameter 'farmerId' cannot be null.");
        else if (farmerId !== undefined)
            url_ += "farmerId=" + encodeURIComponent("" + farmerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByFarmerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByFarmerId(<any>response_);
                } catch (e) {
                    return <Observable<FarmerNutrientRecommendationQuantityDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerNutrientRecommendationQuantityDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByFarmerId(response: HttpResponseBase): Observable<FarmerNutrientRecommendationQuantityDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FarmerNutrientRecommendationQuantityDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerNutrientRecommendationQuantityDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAll(body: FarmerNutrientRecommendationQuantity[] | null | undefined): Observable<FarmerNutrientRecommendationQuantityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FarmerNutrientRecommendationQuantityService/CreateOrUpdateAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAll(<any>response_);
                } catch (e) {
                    return <Observable<FarmerNutrientRecommendationQuantityDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerNutrientRecommendationQuantityDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateAll(response: HttpResponseBase): Observable<FarmerNutrientRecommendationQuantityDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FarmerNutrientRecommendationQuantityDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerNutrientRecommendationQuantityDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FarmerNutrientRecommendationQuantityService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FarmerNutrientSourceQuantityServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param farmerId (optional) 
     * @return Success
     */
    getAllByFarmerId(farmerId: number | undefined): Observable<FarmerNutrientSourceQuantityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FarmerNutrientSourceQuantityService/GetAllByFarmerId?";
        if (farmerId === null)
            throw new Error("The parameter 'farmerId' cannot be null.");
        else if (farmerId !== undefined)
            url_ += "farmerId=" + encodeURIComponent("" + farmerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByFarmerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByFarmerId(<any>response_);
                } catch (e) {
                    return <Observable<FarmerNutrientSourceQuantityDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerNutrientSourceQuantityDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByFarmerId(response: HttpResponseBase): Observable<FarmerNutrientSourceQuantityDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FarmerNutrientSourceQuantityDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerNutrientSourceQuantityDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAll(body: FarmerNutrientSourceQuantity[] | null | undefined): Observable<FarmerNutrientSourceQuantityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FarmerNutrientSourceQuantityService/CreateOrUpdateAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAll(<any>response_);
                } catch (e) {
                    return <Observable<FarmerNutrientSourceQuantityDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerNutrientSourceQuantityDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateAll(response: HttpResponseBase): Observable<FarmerNutrientSourceQuantityDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FarmerNutrientSourceQuantityDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerNutrientSourceQuantityDto[]>(<any>null);
    }
}

@Injectable()
export class FarmerServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param name (optional) 
     * @param hasPassedCertification (optional) 
     * @param isActive (optional) 
     * @param watershedIds (optional) 
     * @param countyIds (optional) 
     * @param hasProfileMissingFields (optional) 
     * @param hasProfileErrors (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | null | undefined, hasPassedCertification: number | null | undefined, isActive: boolean | null | undefined, watershedIds: number[] | null | undefined, countyIds: number[] | null | undefined, hasProfileMissingFields: boolean | null | undefined, hasProfileErrors: boolean | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FarmerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FarmerService/GetAll?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (hasPassedCertification !== undefined)
            url_ += "HasPassedCertification=" + encodeURIComponent("" + hasPassedCertification) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (watershedIds !== undefined)
            watershedIds && watershedIds.forEach(item => { url_ += "WatershedIds=" + encodeURIComponent("" + item) + "&"; });
        if (countyIds !== undefined)
            countyIds && countyIds.forEach(item => { url_ += "CountyIds=" + encodeURIComponent("" + item) + "&"; });
        if (hasProfileMissingFields !== undefined)
            url_ += "HasProfileMissingFields=" + encodeURIComponent("" + hasProfileMissingFields) + "&"; 
        if (hasProfileErrors !== undefined)
            url_ += "HasProfileErrors=" + encodeURIComponent("" + hasProfileErrors) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<FarmerDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FarmerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FarmerDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FarmerDto> {
        let url_ = this.baseUrl + "/api/services/app/FarmerService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FarmerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FarmerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FarmerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: FarmerUpdateDto | undefined): Observable<FarmerDto> {
        let url_ = this.baseUrl + "/api/services/app/FarmerService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FarmerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FarmerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FarmerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: FarmerCreateDto | undefined): Observable<FarmerDto> {
        let url_ = this.baseUrl + "/api/services/app/FarmerService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FarmerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FarmerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FarmerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerDto>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getFarmerIdByUserId(userId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/FarmerService/GetFarmerIdByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFarmerIdByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFarmerIdByUserId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetFarmerIdByUserId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    save(body: FarmerSaveDto | undefined): Observable<FarmerSaveDto> {
        let url_ = this.baseUrl + "/api/services/app/FarmerService/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(<any>response_);
                } catch (e) {
                    return <Observable<FarmerSaveDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerSaveDto>><any>_observableThrow(response_);
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<FarmerSaveDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FarmerSaveDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerSaveDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FarmerService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param farmerId (optional) 
     * @return Success
     */
    updateFarmerProfileErrorFields(farmerId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FarmerService/UpdateFarmerProfileErrorFields?";
        if (farmerId !== undefined)
            url_ += "farmerId=" + encodeURIComponent("" + farmerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFarmerProfileErrorFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFarmerProfileErrorFields(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateFarmerProfileErrorFields(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FarmerWatershedServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param farmerId (optional) 
     * @return Success
     */
    getAllByFarmerId(farmerId: number | undefined): Observable<FarmerWatershedDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FarmerWatershedService/GetAllByFarmerId?";
        if (farmerId === null)
            throw new Error("The parameter 'farmerId' cannot be null.");
        else if (farmerId !== undefined)
            url_ += "farmerId=" + encodeURIComponent("" + farmerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByFarmerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByFarmerId(<any>response_);
                } catch (e) {
                    return <Observable<FarmerWatershedDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerWatershedDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByFarmerId(response: HttpResponseBase): Observable<FarmerWatershedDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FarmerWatershedDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerWatershedDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAll(body: FarmerWatershed[] | null | undefined): Observable<FarmerWatershedDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FarmerWatershedService/CreateOrUpdateAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAll(<any>response_);
                } catch (e) {
                    return <Observable<FarmerWatershedDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FarmerWatershedDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateAll(response: HttpResponseBase): Observable<FarmerWatershedDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FarmerWatershedDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FarmerWatershedDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FarmerWatershedService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ManureStorageDurationServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<ManureStorageDurationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ManureStorageDurationService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ManureStorageDurationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ManureStorageDurationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ManureStorageDurationDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ManureStorageDurationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ManureStorageDurationDto[]>(<any>null);
    }
}

@Injectable()
export class ManureStorageSourceServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<ManureStorageSourceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ManureStorageSourceService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ManureStorageSourceDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ManureStorageSourceDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ManureStorageSourceDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ManureStorageSourceDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ManureStorageSourceDto[]>(<any>null);
    }
}

@Injectable()
export class ManureStorageTypeServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<ManureStorageTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ManureStorageTypeService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ManureStorageTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ManureStorageTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ManureStorageTypeDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ManureStorageTypeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ManureStorageTypeDto[]>(<any>null);
    }
}

@Injectable()
export class NMPTypeServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<NMPTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NMPTypeService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<NMPTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NMPTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NMPTypeDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NMPTypeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NMPTypeDto[]>(<any>null);
    }
}

@Injectable()
export class NotificationServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    sendNotification(emailAddress: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/NotificationService/SendNotification?";
        if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNotification(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSendNotification(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class NutrientRecommendationServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<NutrientRecommendationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NutrientRecommendationService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<NutrientRecommendationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NutrientRecommendationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NutrientRecommendationDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NutrientRecommendationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NutrientRecommendationDto[]>(<any>null);
    }
}

@Injectable()
export class NutrientSourceServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<NutrientSourceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NutrientSourceService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<NutrientSourceDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NutrientSourceDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NutrientSourceDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NutrientSourceDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NutrientSourceDto[]>(<any>null);
    }
}

@Injectable()
export class PasswordResetServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param userName (optional) 
     * @return Success
     */
    canFindUser(userName: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PasswordResetService/CanFindUser?";
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanFindUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanFindUser(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCanFindUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param userName (optional) 
     * @param sendPasswordResetLink (optional) 
     * @return Success
     */
    create(userName: string | null | undefined, sendPasswordResetLink: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PasswordResetService/Create?";
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        if (sendPasswordResetLink === null)
            throw new Error("The parameter 'sendPasswordResetLink' cannot be null.");
        else if (sendPasswordResetLink !== undefined)
            url_ += "sendPasswordResetLink=" + encodeURIComponent("" + sendPasswordResetLink) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    getByToken(token: string | null | undefined): Observable<PasswordResetTokenDto> {
        let url_ = this.baseUrl + "/api/services/app/PasswordResetService/GetByToken?";
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByToken(<any>response_);
                } catch (e) {
                    return <Observable<PasswordResetTokenDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PasswordResetTokenDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByToken(response: HttpResponseBase): Observable<PasswordResetTokenDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PasswordResetTokenDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PasswordResetTokenDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: PasswordResetRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PasswordResetService/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class PrintServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    farmer(farmerId: number): Observable<void> {
        let url_ = this.baseUrl + "/Print/farmer/{farmerId}";
        if (farmerId === undefined || farmerId === null)
            throw new Error("The parameter 'farmerId' must be defined.");
        url_ = url_.replace("{farmerId}", encodeURIComponent("" + farmerId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFarmer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFarmer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processFarmer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    assessment(assessmentId: number): Observable<void> {
        let url_ = this.baseUrl + "/Print/assessment/{assessmentId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssessment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssessment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAssessment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RegistrationTokenServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    create(emailAddress: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/RegistrationTokenService/Create?";
        if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    getByToken(token: string | null | undefined): Observable<RegistrationTokenDto> {
        let url_ = this.baseUrl + "/api/services/app/RegistrationTokenService/GetByToken?";
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByToken(<any>response_);
                } catch (e) {
                    return <Observable<RegistrationTokenDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegistrationTokenDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByToken(response: HttpResponseBase): Observable<RegistrationTokenDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationTokenDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegistrationTokenDto>(<any>null);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    expireToken(token: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/RegistrationTokenService/ExpireToken?";
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExpireToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExpireToken(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processExpireToken(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | null | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<RoleListDtoListResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleListDtoListResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleListDtoListResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(<any>response_);
                } catch (e) {
                    return <Observable<PermissionDtoListResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PermissionDtoListResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDtoListResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<RoleDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class SecurityQuestionServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<SecurityQuestionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SecurityQuestionService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<SecurityQuestionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SecurityQuestionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SecurityQuestionDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SecurityQuestionDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SecurityQuestionDto[]>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TenantDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param farmerId (optional) 
     * @return Success
     */
    sendConfirmationEmail(userId: number | undefined, farmerId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/SendConfirmationEmail?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (farmerId === null)
            throw new Error("The parameter 'farmerId' cannot be null.");
        else if (farmerId !== undefined)
            url_ += "farmerId=" + encodeURIComponent("" + farmerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirmationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmationEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendConfirmationEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<RoleDtoListResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDtoListResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoListResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    requestDeletePrivateData(emailAddress: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/RequestDeletePrivateData?";
        if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestDeletePrivateData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestDeletePrivateData(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRequestDeletePrivateData(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    doesUserExist(name: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/DoesUserExist?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoesUserExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoesUserExist(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDoesUserExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<UserDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class UserSecurityQuestionAnswerServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addAll(body: UserSecurityQuestionAnswer[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/UserSecurityQuestionAnswerService/AddAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAll(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAddAll(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param emailOrUserName (optional) 
     * @param questionId (optional) 
     * @param answer (optional) 
     * @return Success
     */
    checkIsAnswerCorrect(emailOrUserName: string | null | undefined, questionId: number | undefined, answer: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/UserSecurityQuestionAnswerService/CheckIsAnswerCorrect?";
        if (emailOrUserName !== undefined)
            url_ += "emailOrUserName=" + encodeURIComponent("" + emailOrUserName) + "&"; 
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "questionId=" + encodeURIComponent("" + questionId) + "&"; 
        if (answer !== undefined)
            url_ += "answer=" + encodeURIComponent("" + answer) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIsAnswerCorrect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsAnswerCorrect(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsAnswerCorrect(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param emailOrUserName (optional) 
     * @return Success
     */
    getSecurityQuestion(emailOrUserName: string | null | undefined): Observable<SecurityQuestion> {
        let url_ = this.baseUrl + "/api/services/app/UserSecurityQuestionAnswerService/GetSecurityQuestion?";
        if (emailOrUserName !== undefined)
            url_ += "emailOrUserName=" + encodeURIComponent("" + emailOrUserName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecurityQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecurityQuestion(<any>response_);
                } catch (e) {
                    return <Observable<SecurityQuestion>><any>_observableThrow(e);
                }
            } else
                return <Observable<SecurityQuestion>><any>_observableThrow(response_);
        }));
    }

    protected processGetSecurityQuestion(response: HttpResponseBase): Observable<SecurityQuestion> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityQuestion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SecurityQuestion>(<any>null);
    }
}

@Injectable()
export class VVerificationQuestionAnswerServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param verificationId (optional) 
     * @return Success
     */
    getAllByVerificationId(verificationId: number | null | undefined): Observable<VVerificationQuestionWithAnswersGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationQuestionAnswerService/GetAllByVerificationId?";
        if (verificationId !== undefined)
            url_ += "verificationId=" + encodeURIComponent("" + verificationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByVerificationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByVerificationId(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationQuestionWithAnswersGroupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationQuestionWithAnswersGroupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByVerificationId(response: HttpResponseBase): Observable<VVerificationQuestionWithAnswersGroupDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(VVerificationQuestionWithAnswersGroupDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationQuestionWithAnswersGroupDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: VVerificationQuestionAnswerCreateDto | undefined): Observable<VVerificationQuestionAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationQuestionAnswerService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationQuestionAnswerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationQuestionAnswerDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VVerificationQuestionAnswerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationQuestionAnswerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationQuestionAnswerDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: VVerificationQuestionAnswerUpdateDto | undefined): Observable<VVerificationQuestionAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationQuestionAnswerService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationQuestionAnswerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationQuestionAnswerDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VVerificationQuestionAnswerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationQuestionAnswerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationQuestionAnswerDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    save(body: VVerificationQuestionAnswerDto | undefined): Observable<VVerificationQuestionAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationQuestionAnswerService/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationQuestionAnswerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationQuestionAnswerDto>><any>_observableThrow(response_);
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<VVerificationQuestionAnswerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationQuestionAnswerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationQuestionAnswerDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<VVerificationQuestionAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationQuestionAnswerService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationQuestionAnswerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationQuestionAnswerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VVerificationQuestionAnswerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationQuestionAnswerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationQuestionAnswerDto>(<any>null);
    }

    /**
     * @param verificationId (optional) 
     * @return Success
     */
    getAll(verificationId: number | undefined): Observable<VVerificationQuestionAnswerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationQuestionAnswerService/GetAll?";
        if (verificationId === null)
            throw new Error("The parameter 'verificationId' cannot be null.");
        else if (verificationId !== undefined)
            url_ += "VerificationId=" + encodeURIComponent("" + verificationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationQuestionAnswerDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationQuestionAnswerDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VVerificationQuestionAnswerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationQuestionAnswerDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationQuestionAnswerDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationQuestionAnswerService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class VVerificationQuestionNoteServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: VVerificationQuestionNoteCreateDto | undefined): Observable<VVerificationQuestionNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationQuestionNoteService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationQuestionNoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationQuestionNoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VVerificationQuestionNoteDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationQuestionNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationQuestionNoteDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: VVerificationQuestionNoteUpdateDto | undefined): Observable<VVerificationQuestionNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationQuestionNoteService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationQuestionNoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationQuestionNoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VVerificationQuestionNoteDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationQuestionNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationQuestionNoteDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    save(body: VVerificationQuestionNoteDto | undefined): Observable<VVerificationQuestionNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationQuestionNoteService/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationQuestionNoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationQuestionNoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<VVerificationQuestionNoteDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationQuestionNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationQuestionNoteDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<VVerificationQuestionNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationQuestionNoteService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationQuestionNoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationQuestionNoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VVerificationQuestionNoteDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationQuestionNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationQuestionNoteDto>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VVerificationQuestionNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationQuestionNoteService/GetAll?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationQuestionNoteDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationQuestionNoteDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VVerificationQuestionNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationQuestionNoteDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationQuestionNoteDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationQuestionNoteService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class VVerificationServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param countyId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(countyId: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VVerificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationService/GetAll?";
        if (countyId !== undefined)
            url_ += "CountyId=" + encodeURIComponent("" + countyId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VVerificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationDtoPagedResultDto>(<any>null);
    }

    /**
     * @param countyId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllWithQuestionAnswers(countyId: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetAllWithQuestionAnswersDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationService/GetAllWithQuestionAnswers?";
        if (countyId !== undefined)
            url_ += "CountyId=" + encodeURIComponent("" + countyId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithQuestionAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithQuestionAnswers(<any>response_);
                } catch (e) {
                    return <Observable<GetAllWithQuestionAnswersDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAllWithQuestionAnswersDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWithQuestionAnswers(response: HttpResponseBase): Observable<GetAllWithQuestionAnswersDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllWithQuestionAnswersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllWithQuestionAnswersDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<VVerificationDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VVerificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: VVerificationUpdateDto | undefined): Observable<VVerificationDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VVerificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: VVerificationCreateDto | undefined): Observable<VVerificationDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VVerificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    save(body: VVerificationDto | undefined): Observable<VVerificationDto> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationService/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(<any>response_);
                } catch (e) {
                    return <Observable<VVerificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VVerificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<VVerificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VVerificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VVerificationDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VVerificationService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class WatershedServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<WatershedDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WatershedService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<WatershedDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WatershedDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WatershedDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WatershedDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WatershedDto[]>(<any>null);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string | undefined;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data; 
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string | undefined;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class RegisterInput implements IRegisterInput {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    password: string | undefined;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data; 
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    password: string | undefined;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data; 
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class HelpDeskEmailRequest implements IHelpDeskEmailRequest {
    subject: string | undefined;
    message: string | undefined;

    constructor(data?: IHelpDeskEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): HelpDeskEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HelpDeskEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["message"] = this.message;
        return data; 
    }

    clone(): HelpDeskEmailRequest {
        const json = this.toJSON();
        let result = new HelpDeskEmailRequest();
        result.init(json);
        return result;
    }
}

export interface IHelpDeskEmailRequest {
    subject: string | undefined;
    message: string | undefined;
}

export class CaptchaModel implements ICaptchaModel {
    captchaId: string | undefined;
    userEnteredCaptchaCode: string | undefined;

    constructor(data?: ICaptchaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captchaId = _data["captchaId"];
            this.userEnteredCaptchaCode = _data["userEnteredCaptchaCode"];
        }
    }

    static fromJS(data: any): CaptchaModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaptchaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captchaId"] = this.captchaId;
        data["userEnteredCaptchaCode"] = this.userEnteredCaptchaCode;
        return data; 
    }

    clone(): CaptchaModel {
        const json = this.toJSON();
        let result = new CaptchaModel();
        result.init(json);
        return result;
    }
}

export interface ICaptchaModel {
    captchaId: string | undefined;
    userEnteredCaptchaCode: string | undefined;
}

export enum CAnswerLevelEnum {
    _0 = 0,
    _1 = 1,
}

export class CAnswerCreateInput implements ICAnswerCreateInput {
    categoryId: number;
    answer: string | undefined;
    objectId: number | undefined;
    answerLevelId: CAnswerLevelEnum;
    certificationId: number;

    constructor(data?: ICAnswerCreateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.answer = _data["answer"];
            this.objectId = _data["objectId"];
            this.answerLevelId = _data["answerLevelId"];
            this.certificationId = _data["certificationId"];
        }
    }

    static fromJS(data: any): CAnswerCreateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CAnswerCreateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["answer"] = this.answer;
        data["objectId"] = this.objectId;
        data["answerLevelId"] = this.answerLevelId;
        data["certificationId"] = this.certificationId;
        return data; 
    }

    clone(): CAnswerCreateInput {
        const json = this.toJSON();
        let result = new CAnswerCreateInput();
        result.init(json);
        return result;
    }
}

export interface ICAnswerCreateInput {
    categoryId: number;
    answer: string | undefined;
    objectId: number | undefined;
    answerLevelId: CAnswerLevelEnum;
    certificationId: number;
}

export class CAnswerDto implements ICAnswerDto {
    categoryId: number;
    answer: string | undefined;
    objectId: number | undefined;
    answerLevelId: CAnswerLevelEnum;
    certificationId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.answer = _data["answer"];
            this.objectId = _data["objectId"];
            this.answerLevelId = _data["answerLevelId"];
            this.certificationId = _data["certificationId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["answer"] = this.answer;
        data["objectId"] = this.objectId;
        data["answerLevelId"] = this.answerLevelId;
        data["certificationId"] = this.certificationId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CAnswerDto {
        const json = this.toJSON();
        let result = new CAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ICAnswerDto {
    categoryId: number;
    answer: string | undefined;
    objectId: number | undefined;
    answerLevelId: CAnswerLevelEnum;
    certificationId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CAnswerUpdateInput implements ICAnswerUpdateInput {
    id: number;
    categoryId: number;
    answer: string | undefined;
    objectId: number | undefined;
    answerLevelId: CAnswerLevelEnum;
    certificationId: number;

    constructor(data?: ICAnswerUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryId = _data["categoryId"];
            this.answer = _data["answer"];
            this.objectId = _data["objectId"];
            this.answerLevelId = _data["answerLevelId"];
            this.certificationId = _data["certificationId"];
        }
    }

    static fromJS(data: any): CAnswerUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CAnswerUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryId"] = this.categoryId;
        data["answer"] = this.answer;
        data["objectId"] = this.objectId;
        data["answerLevelId"] = this.answerLevelId;
        data["certificationId"] = this.certificationId;
        return data; 
    }

    clone(): CAnswerUpdateInput {
        const json = this.toJSON();
        let result = new CAnswerUpdateInput();
        result.init(json);
        return result;
    }
}

export interface ICAnswerUpdateInput {
    id: number;
    categoryId: number;
    answer: string | undefined;
    objectId: number | undefined;
    answerLevelId: CAnswerLevelEnum;
    certificationId: number;
}

export class CAnswerDtoPagedResultDto implements ICAnswerDtoPagedResultDto {
    totalCount: number;
    items: CAnswerDto[] | undefined;

    constructor(data?: ICAnswerDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CAnswerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CAnswerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CAnswerDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CAnswerDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICAnswerDtoPagedResultDto {
    totalCount: number;
    items: CAnswerDto[] | undefined;
}

export enum CBehaviorTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum CAnswerTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CCategoryAnswerDto implements ICCategoryAnswerDto {
    id: number;
    label: string | undefined;
    isActive: boolean;
    parentId: number | undefined;
    behaviorTypeId: CBehaviorTypeEnum;
    answerTypeId: CAnswerTypeEnum;
    children: CCategoryAnswerDto[] | undefined;
    answers: Answers | undefined;
    score: number;
    order: number;
    collapsed: boolean;

    constructor(data?: ICCategoryAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.isActive = _data["isActive"];
            this.parentId = _data["parentId"];
            this.behaviorTypeId = _data["behaviorTypeId"];
            this.answerTypeId = _data["answerTypeId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(CCategoryAnswerDto.fromJS(item));
            }
            this.answers = _data["answers"] ? Answers.fromJS(_data["answers"]) : <any>undefined;
            this.score = _data["score"];
            this.order = _data["order"];
            this.collapsed = _data["collapsed"];
        }
    }

    static fromJS(data: any): CCategoryAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CCategoryAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["isActive"] = this.isActive;
        data["parentId"] = this.parentId;
        data["behaviorTypeId"] = this.behaviorTypeId;
        data["answerTypeId"] = this.answerTypeId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["answers"] = this.answers ? this.answers.toJSON() : <any>undefined;
        data["score"] = this.score;
        data["order"] = this.order;
        data["collapsed"] = this.collapsed;
        return data; 
    }

    clone(): CCategoryAnswerDto {
        const json = this.toJSON();
        let result = new CCategoryAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ICCategoryAnswerDto {
    id: number;
    label: string | undefined;
    isActive: boolean;
    parentId: number | undefined;
    behaviorTypeId: CBehaviorTypeEnum;
    answerTypeId: CAnswerTypeEnum;
    children: CCategoryAnswerDto[] | undefined;
    answers: Answers | undefined;
    score: number;
    order: number;
    collapsed: boolean;
}

export class CCertificationCategorySummaryDto implements ICCertificationCategorySummaryDto {
    certificationId: number | undefined;
    categoryId: number | undefined;
    categoryLabel: string | undefined;
    score: number | undefined;
    id: number;

    constructor(data?: ICCertificationCategorySummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.certificationId = _data["certificationId"];
            this.categoryId = _data["categoryId"];
            this.categoryLabel = _data["categoryLabel"];
            this.score = _data["score"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CCertificationCategorySummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CCertificationCategorySummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificationId"] = this.certificationId;
        data["categoryId"] = this.categoryId;
        data["categoryLabel"] = this.categoryLabel;
        data["score"] = this.score;
        data["id"] = this.id;
        return data; 
    }

    clone(): CCertificationCategorySummaryDto {
        const json = this.toJSON();
        let result = new CCertificationCategorySummaryDto();
        result.init(json);
        return result;
    }
}

export interface ICCertificationCategorySummaryDto {
    certificationId: number | undefined;
    categoryId: number | undefined;
    categoryLabel: string | undefined;
    score: number | undefined;
    id: number;
}

export class CCertificationCreateInput implements ICCertificationCreateInput {
    farmerId: number;
    year: number;

    constructor(data?: ICCertificationCreateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): CCertificationCreateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CCertificationCreateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["year"] = this.year;
        return data; 
    }

    clone(): CCertificationCreateInput {
        const json = this.toJSON();
        let result = new CCertificationCreateInput();
        result.init(json);
        return result;
    }
}

export interface ICCertificationCreateInput {
    farmerId: number;
    year: number;
}

export enum CCertificationStatusEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CCertificationDto implements ICCertificationDto {
    farmerId: number;
    statusId: CCertificationStatusEnum;
    year: number;
    isActive: boolean;
    score: number | undefined;
    isPassing: boolean | undefined;
    completionMessage: string | undefined;
    ownedAcres: number | undefined;
    rentedAcres: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;

    constructor(data?: ICCertificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.statusId = _data["statusId"];
            this.year = _data["year"];
            this.isActive = _data["isActive"];
            this.score = _data["score"];
            this.isPassing = _data["isPassing"];
            this.completionMessage = _data["completionMessage"];
            this.ownedAcres = _data["ownedAcres"];
            this.rentedAcres = _data["rentedAcres"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CCertificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CCertificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["statusId"] = this.statusId;
        data["year"] = this.year;
        data["isActive"] = this.isActive;
        data["score"] = this.score;
        data["isPassing"] = this.isPassing;
        data["completionMessage"] = this.completionMessage;
        data["ownedAcres"] = this.ownedAcres;
        data["rentedAcres"] = this.rentedAcres;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data; 
    }

    clone(): CCertificationDto {
        const json = this.toJSON();
        let result = new CCertificationDto();
        result.init(json);
        return result;
    }
}

export interface ICCertificationDto {
    farmerId: number;
    statusId: CCertificationStatusEnum;
    year: number;
    isActive: boolean;
    score: number | undefined;
    isPassing: boolean | undefined;
    completionMessage: string | undefined;
    ownedAcres: number | undefined;
    rentedAcres: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;
}

export class CCertificationUpdateInput implements ICCertificationUpdateInput {
    id: number;
    statusId: CCertificationStatusEnum;
    score: number | undefined;
    isPassing: boolean | undefined;
    completionMessage: string | undefined;
    ownedAcres: number | undefined;
    rentedAcres: number | undefined;
    farmerId: number;
    year: number;

    constructor(data?: ICCertificationUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusId = _data["statusId"];
            this.score = _data["score"];
            this.isPassing = _data["isPassing"];
            this.completionMessage = _data["completionMessage"];
            this.ownedAcres = _data["ownedAcres"];
            this.rentedAcres = _data["rentedAcres"];
            this.farmerId = _data["farmerId"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): CCertificationUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CCertificationUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusId"] = this.statusId;
        data["score"] = this.score;
        data["isPassing"] = this.isPassing;
        data["completionMessage"] = this.completionMessage;
        data["ownedAcres"] = this.ownedAcres;
        data["rentedAcres"] = this.rentedAcres;
        data["farmerId"] = this.farmerId;
        data["year"] = this.year;
        return data; 
    }

    clone(): CCertificationUpdateInput {
        const json = this.toJSON();
        let result = new CCertificationUpdateInput();
        result.init(json);
        return result;
    }
}

export interface ICCertificationUpdateInput {
    id: number;
    statusId: CCertificationStatusEnum;
    score: number | undefined;
    isPassing: boolean | undefined;
    completionMessage: string | undefined;
    ownedAcres: number | undefined;
    rentedAcres: number | undefined;
    farmerId: number;
    year: number;
}

export class CCertificationDtoPagedResultDto implements ICCertificationDtoPagedResultDto {
    totalCount: number;
    items: CCertificationDto[] | undefined;

    constructor(data?: ICCertificationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CCertificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CCertificationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CCertificationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CCertificationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CCertificationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICCertificationDtoPagedResultDto {
    totalCount: number;
    items: CCertificationDto[] | undefined;
}

export class SoilTestingFrequencyScoring implements ISoilTestingFrequencyScoring {
    readonly label: string | undefined;
    points: number;
    readonly totalPossiblePointsPerQuestion: number;

    constructor(data?: ISoilTestingFrequencyScoring) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            (<any>this).totalPossiblePointsPerQuestion = _data["totalPossiblePointsPerQuestion"];
        }
    }

    static fromJS(data: any): SoilTestingFrequencyScoring {
        data = typeof data === 'object' ? data : {};
        let result = new SoilTestingFrequencyScoring();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["totalPossiblePointsPerQuestion"] = this.totalPossiblePointsPerQuestion;
        return data; 
    }

    clone(): SoilTestingFrequencyScoring {
        const json = this.toJSON();
        let result = new SoilTestingFrequencyScoring();
        result.init(json);
        return result;
    }
}

export interface ISoilTestingFrequencyScoring {
    label: string | undefined;
    points: number;
    totalPossiblePointsPerQuestion: number;
}

export class SoilTestingFrequency implements ISoilTestingFrequency {
    readonly label: string | undefined;
    points: number;
    percentageScore: number;
    readonly numberOfCategories: number;
    readonly weightedPoints: number;
    soilTestingFrequencyScoring: SoilTestingFrequencyScoring;

    constructor(data?: ISoilTestingFrequency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            this.percentageScore = _data["percentageScore"];
            (<any>this).numberOfCategories = _data["numberOfCategories"];
            (<any>this).weightedPoints = _data["weightedPoints"];
            this.soilTestingFrequencyScoring = _data["soilTestingFrequencyScoring"] ? SoilTestingFrequencyScoring.fromJS(_data["soilTestingFrequencyScoring"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SoilTestingFrequency {
        data = typeof data === 'object' ? data : {};
        let result = new SoilTestingFrequency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["percentageScore"] = this.percentageScore;
        data["numberOfCategories"] = this.numberOfCategories;
        data["weightedPoints"] = this.weightedPoints;
        data["soilTestingFrequencyScoring"] = this.soilTestingFrequencyScoring ? this.soilTestingFrequencyScoring.toJSON() : <any>undefined;
        return data; 
    }

    clone(): SoilTestingFrequency {
        const json = this.toJSON();
        let result = new SoilTestingFrequency();
        result.init(json);
        return result;
    }
}

export interface ISoilTestingFrequency {
    label: string | undefined;
    points: number;
    percentageScore: number;
    numberOfCategories: number;
    weightedPoints: number;
    soilTestingFrequencyScoring: SoilTestingFrequencyScoring;
}

export class SoilTestFrequency implements ISoilTestFrequency {
    readonly label: string | undefined;
    percentageScore: number;
    overallPercentageScore: number;
    readonly collapsed: boolean;
    soilTestingFrequency: SoilTestingFrequency;

    constructor(data?: ISoilTestFrequency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.percentageScore = _data["percentageScore"];
            this.overallPercentageScore = _data["overallPercentageScore"];
            (<any>this).collapsed = _data["collapsed"];
            this.soilTestingFrequency = _data["soilTestingFrequency"] ? SoilTestingFrequency.fromJS(_data["soilTestingFrequency"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SoilTestFrequency {
        data = typeof data === 'object' ? data : {};
        let result = new SoilTestFrequency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["percentageScore"] = this.percentageScore;
        data["overallPercentageScore"] = this.overallPercentageScore;
        data["collapsed"] = this.collapsed;
        data["soilTestingFrequency"] = this.soilTestingFrequency ? this.soilTestingFrequency.toJSON() : <any>undefined;
        return data; 
    }

    clone(): SoilTestFrequency {
        const json = this.toJSON();
        let result = new SoilTestFrequency();
        result.init(json);
        return result;
    }
}

export interface ISoilTestFrequency {
    label: string | undefined;
    percentageScore: number;
    overallPercentageScore: number;
    collapsed: boolean;
    soilTestingFrequency: SoilTestingFrequency;
}

export class SoilTestingIntensityScoring implements ISoilTestingIntensityScoring {
    readonly label: string | undefined;
    points: number;
    readonly totalPossiblePointsPerQuestion: number;

    constructor(data?: ISoilTestingIntensityScoring) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            (<any>this).totalPossiblePointsPerQuestion = _data["totalPossiblePointsPerQuestion"];
        }
    }

    static fromJS(data: any): SoilTestingIntensityScoring {
        data = typeof data === 'object' ? data : {};
        let result = new SoilTestingIntensityScoring();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["totalPossiblePointsPerQuestion"] = this.totalPossiblePointsPerQuestion;
        return data; 
    }

    clone(): SoilTestingIntensityScoring {
        const json = this.toJSON();
        let result = new SoilTestingIntensityScoring();
        result.init(json);
        return result;
    }
}

export interface ISoilTestingIntensityScoring {
    label: string | undefined;
    points: number;
    totalPossiblePointsPerQuestion: number;
}

export class SoilTestingIntensity implements ISoilTestingIntensity {
    readonly label: string | undefined;
    points: number;
    percentageScore: number;
    readonly numberOfCategories: number;
    readonly weightedPoints: number;
    soilTestingIntensityScoring: SoilTestingIntensityScoring;

    constructor(data?: ISoilTestingIntensity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            this.percentageScore = _data["percentageScore"];
            (<any>this).numberOfCategories = _data["numberOfCategories"];
            (<any>this).weightedPoints = _data["weightedPoints"];
            this.soilTestingIntensityScoring = _data["soilTestingIntensityScoring"] ? SoilTestingIntensityScoring.fromJS(_data["soilTestingIntensityScoring"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SoilTestingIntensity {
        data = typeof data === 'object' ? data : {};
        let result = new SoilTestingIntensity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["percentageScore"] = this.percentageScore;
        data["numberOfCategories"] = this.numberOfCategories;
        data["weightedPoints"] = this.weightedPoints;
        data["soilTestingIntensityScoring"] = this.soilTestingIntensityScoring ? this.soilTestingIntensityScoring.toJSON() : <any>undefined;
        return data; 
    }

    clone(): SoilTestingIntensity {
        const json = this.toJSON();
        let result = new SoilTestingIntensity();
        result.init(json);
        return result;
    }
}

export interface ISoilTestingIntensity {
    label: string | undefined;
    points: number;
    percentageScore: number;
    numberOfCategories: number;
    weightedPoints: number;
    soilTestingIntensityScoring: SoilTestingIntensityScoring;
}

export class SoilTestIntensity implements ISoilTestIntensity {
    readonly label: string | undefined;
    percentageScore: number;
    overallPercentageScore: number;
    readonly collapsed: boolean;
    soilTestingIntensity: SoilTestingIntensity;

    constructor(data?: ISoilTestIntensity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.percentageScore = _data["percentageScore"];
            this.overallPercentageScore = _data["overallPercentageScore"];
            (<any>this).collapsed = _data["collapsed"];
            this.soilTestingIntensity = _data["soilTestingIntensity"] ? SoilTestingIntensity.fromJS(_data["soilTestingIntensity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SoilTestIntensity {
        data = typeof data === 'object' ? data : {};
        let result = new SoilTestIntensity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["percentageScore"] = this.percentageScore;
        data["overallPercentageScore"] = this.overallPercentageScore;
        data["collapsed"] = this.collapsed;
        data["soilTestingIntensity"] = this.soilTestingIntensity ? this.soilTestingIntensity.toJSON() : <any>undefined;
        return data; 
    }

    clone(): SoilTestIntensity {
        const json = this.toJSON();
        let result = new SoilTestIntensity();
        result.init(json);
        return result;
    }
}

export interface ISoilTestIntensity {
    label: string | undefined;
    percentageScore: number;
    overallPercentageScore: number;
    collapsed: boolean;
    soilTestingIntensity: SoilTestingIntensity;
}

export class ManureApplicationRecommendation implements IManureApplicationRecommendation {
    readonly label: string | undefined;
    points: number;
    readonly totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;

    constructor(data?: IManureApplicationRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            (<any>this).totalPossiblePointsPerQuestion = _data["totalPossiblePointsPerQuestion"];
            this.didCalculatePoints = _data["didCalculatePoints"];
        }
    }

    static fromJS(data: any): ManureApplicationRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new ManureApplicationRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["totalPossiblePointsPerQuestion"] = this.totalPossiblePointsPerQuestion;
        data["didCalculatePoints"] = this.didCalculatePoints;
        return data; 
    }

    clone(): ManureApplicationRecommendation {
        const json = this.toJSON();
        let result = new ManureApplicationRecommendation();
        result.init(json);
        return result;
    }
}

export interface IManureApplicationRecommendation {
    label: string | undefined;
    points: number;
    totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;
}

export class BiosolidsApplicationRecommendation implements IBiosolidsApplicationRecommendation {
    readonly label: string | undefined;
    points: number;
    readonly totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;

    constructor(data?: IBiosolidsApplicationRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            (<any>this).totalPossiblePointsPerQuestion = _data["totalPossiblePointsPerQuestion"];
            this.didCalculatePoints = _data["didCalculatePoints"];
        }
    }

    static fromJS(data: any): BiosolidsApplicationRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new BiosolidsApplicationRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["totalPossiblePointsPerQuestion"] = this.totalPossiblePointsPerQuestion;
        data["didCalculatePoints"] = this.didCalculatePoints;
        return data; 
    }

    clone(): BiosolidsApplicationRecommendation {
        const json = this.toJSON();
        let result = new BiosolidsApplicationRecommendation();
        result.init(json);
        return result;
    }
}

export interface IBiosolidsApplicationRecommendation {
    label: string | undefined;
    points: number;
    totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;
}

export class OtherOrganicNutrientSources implements IOtherOrganicNutrientSources {
    readonly label: string | undefined;
    points: number;
    readonly totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;

    constructor(data?: IOtherOrganicNutrientSources) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            (<any>this).totalPossiblePointsPerQuestion = _data["totalPossiblePointsPerQuestion"];
            this.didCalculatePoints = _data["didCalculatePoints"];
        }
    }

    static fromJS(data: any): OtherOrganicNutrientSources {
        data = typeof data === 'object' ? data : {};
        let result = new OtherOrganicNutrientSources();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["totalPossiblePointsPerQuestion"] = this.totalPossiblePointsPerQuestion;
        data["didCalculatePoints"] = this.didCalculatePoints;
        return data; 
    }

    clone(): OtherOrganicNutrientSources {
        const json = this.toJSON();
        let result = new OtherOrganicNutrientSources();
        result.init(json);
        return result;
    }
}

export interface IOtherOrganicNutrientSources {
    label: string | undefined;
    points: number;
    totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;
}

export class CommericalPhosphorusFertilizerRecommendations implements ICommericalPhosphorusFertilizerRecommendations {
    readonly label: string | undefined;
    points: number;
    readonly totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;

    constructor(data?: ICommericalPhosphorusFertilizerRecommendations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            (<any>this).totalPossiblePointsPerQuestion = _data["totalPossiblePointsPerQuestion"];
            this.didCalculatePoints = _data["didCalculatePoints"];
        }
    }

    static fromJS(data: any): CommericalPhosphorusFertilizerRecommendations {
        data = typeof data === 'object' ? data : {};
        let result = new CommericalPhosphorusFertilizerRecommendations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["totalPossiblePointsPerQuestion"] = this.totalPossiblePointsPerQuestion;
        data["didCalculatePoints"] = this.didCalculatePoints;
        return data; 
    }

    clone(): CommericalPhosphorusFertilizerRecommendations {
        const json = this.toJSON();
        let result = new CommericalPhosphorusFertilizerRecommendations();
        result.init(json);
        return result;
    }
}

export interface ICommericalPhosphorusFertilizerRecommendations {
    label: string | undefined;
    points: number;
    totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;
}

export class CommericalNitrogenFertilizerRecommendations implements ICommericalNitrogenFertilizerRecommendations {
    readonly label: string | undefined;
    points: number;
    readonly totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;

    constructor(data?: ICommericalNitrogenFertilizerRecommendations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            (<any>this).totalPossiblePointsPerQuestion = _data["totalPossiblePointsPerQuestion"];
            this.didCalculatePoints = _data["didCalculatePoints"];
        }
    }

    static fromJS(data: any): CommericalNitrogenFertilizerRecommendations {
        data = typeof data === 'object' ? data : {};
        let result = new CommericalNitrogenFertilizerRecommendations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["totalPossiblePointsPerQuestion"] = this.totalPossiblePointsPerQuestion;
        data["didCalculatePoints"] = this.didCalculatePoints;
        return data; 
    }

    clone(): CommericalNitrogenFertilizerRecommendations {
        const json = this.toJSON();
        let result = new CommericalNitrogenFertilizerRecommendations();
        result.init(json);
        return result;
    }
}

export interface ICommericalNitrogenFertilizerRecommendations {
    label: string | undefined;
    points: number;
    totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;
}

export class NutrientApplicationRecommendations implements INutrientApplicationRecommendations {
    readonly label: string | undefined;
    points: number;
    percentageScore: number;
    readonly numberOfCategories: number;
    readonly weightedPoints: number;
    manureApplicationRecommendation: ManureApplicationRecommendation;
    biosolidsApplicationRecommendation: BiosolidsApplicationRecommendation;
    otherOrganicNutrientSources: OtherOrganicNutrientSources;
    commericalPhosphorusFertilizerRecommendations: CommericalPhosphorusFertilizerRecommendations;
    commericalNitrogenFertilizerRecommendations: CommericalNitrogenFertilizerRecommendations;

    constructor(data?: INutrientApplicationRecommendations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            this.percentageScore = _data["percentageScore"];
            (<any>this).numberOfCategories = _data["numberOfCategories"];
            (<any>this).weightedPoints = _data["weightedPoints"];
            this.manureApplicationRecommendation = _data["manureApplicationRecommendation"] ? ManureApplicationRecommendation.fromJS(_data["manureApplicationRecommendation"]) : <any>undefined;
            this.biosolidsApplicationRecommendation = _data["biosolidsApplicationRecommendation"] ? BiosolidsApplicationRecommendation.fromJS(_data["biosolidsApplicationRecommendation"]) : <any>undefined;
            this.otherOrganicNutrientSources = _data["otherOrganicNutrientSources"] ? OtherOrganicNutrientSources.fromJS(_data["otherOrganicNutrientSources"]) : <any>undefined;
            this.commericalPhosphorusFertilizerRecommendations = _data["commericalPhosphorusFertilizerRecommendations"] ? CommericalPhosphorusFertilizerRecommendations.fromJS(_data["commericalPhosphorusFertilizerRecommendations"]) : <any>undefined;
            this.commericalNitrogenFertilizerRecommendations = _data["commericalNitrogenFertilizerRecommendations"] ? CommericalNitrogenFertilizerRecommendations.fromJS(_data["commericalNitrogenFertilizerRecommendations"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NutrientApplicationRecommendations {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientApplicationRecommendations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["percentageScore"] = this.percentageScore;
        data["numberOfCategories"] = this.numberOfCategories;
        data["weightedPoints"] = this.weightedPoints;
        data["manureApplicationRecommendation"] = this.manureApplicationRecommendation ? this.manureApplicationRecommendation.toJSON() : <any>undefined;
        data["biosolidsApplicationRecommendation"] = this.biosolidsApplicationRecommendation ? this.biosolidsApplicationRecommendation.toJSON() : <any>undefined;
        data["otherOrganicNutrientSources"] = this.otherOrganicNutrientSources ? this.otherOrganicNutrientSources.toJSON() : <any>undefined;
        data["commericalPhosphorusFertilizerRecommendations"] = this.commericalPhosphorusFertilizerRecommendations ? this.commericalPhosphorusFertilizerRecommendations.toJSON() : <any>undefined;
        data["commericalNitrogenFertilizerRecommendations"] = this.commericalNitrogenFertilizerRecommendations ? this.commericalNitrogenFertilizerRecommendations.toJSON() : <any>undefined;
        return data; 
    }

    clone(): NutrientApplicationRecommendations {
        const json = this.toJSON();
        let result = new NutrientApplicationRecommendations();
        result.init(json);
        return result;
    }
}

export interface INutrientApplicationRecommendations {
    label: string | undefined;
    points: number;
    percentageScore: number;
    numberOfCategories: number;
    weightedPoints: number;
    manureApplicationRecommendation: ManureApplicationRecommendation;
    biosolidsApplicationRecommendation: BiosolidsApplicationRecommendation;
    otherOrganicNutrientSources: OtherOrganicNutrientSources;
    commericalPhosphorusFertilizerRecommendations: CommericalPhosphorusFertilizerRecommendations;
    commericalNitrogenFertilizerRecommendations: CommericalNitrogenFertilizerRecommendations;
}

export class NutrientApplicationRate implements INutrientApplicationRate {
    readonly label: string | undefined;
    percentageScore: number;
    overallPercentageScore: number;
    readonly collapsed: boolean;
    nutrientApplicationRecommendations: NutrientApplicationRecommendations;

    constructor(data?: INutrientApplicationRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.percentageScore = _data["percentageScore"];
            this.overallPercentageScore = _data["overallPercentageScore"];
            (<any>this).collapsed = _data["collapsed"];
            this.nutrientApplicationRecommendations = _data["nutrientApplicationRecommendations"] ? NutrientApplicationRecommendations.fromJS(_data["nutrientApplicationRecommendations"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NutrientApplicationRate {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientApplicationRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["percentageScore"] = this.percentageScore;
        data["overallPercentageScore"] = this.overallPercentageScore;
        data["collapsed"] = this.collapsed;
        data["nutrientApplicationRecommendations"] = this.nutrientApplicationRecommendations ? this.nutrientApplicationRecommendations.toJSON() : <any>undefined;
        return data; 
    }

    clone(): NutrientApplicationRate {
        const json = this.toJSON();
        let result = new NutrientApplicationRate();
        result.init(json);
        return result;
    }
}

export interface INutrientApplicationRate {
    label: string | undefined;
    percentageScore: number;
    overallPercentageScore: number;
    collapsed: boolean;
    nutrientApplicationRecommendations: NutrientApplicationRecommendations;
}

export class CommercialPhosphorusFertilizerApplication implements ICommercialPhosphorusFertilizerApplication {
    readonly label: string | undefined;
    points: number;
    readonly totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;

    constructor(data?: ICommercialPhosphorusFertilizerApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            (<any>this).totalPossiblePointsPerQuestion = _data["totalPossiblePointsPerQuestion"];
            this.didCalculatePoints = _data["didCalculatePoints"];
        }
    }

    static fromJS(data: any): CommercialPhosphorusFertilizerApplication {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialPhosphorusFertilizerApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["totalPossiblePointsPerQuestion"] = this.totalPossiblePointsPerQuestion;
        data["didCalculatePoints"] = this.didCalculatePoints;
        return data; 
    }

    clone(): CommercialPhosphorusFertilizerApplication {
        const json = this.toJSON();
        let result = new CommercialPhosphorusFertilizerApplication();
        result.init(json);
        return result;
    }
}

export interface ICommercialPhosphorusFertilizerApplication {
    label: string | undefined;
    points: number;
    totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;
}

export class CommercialNitrogenFertilizerApplication implements ICommercialNitrogenFertilizerApplication {
    readonly label: string | undefined;
    points: number;
    readonly totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;

    constructor(data?: ICommercialNitrogenFertilizerApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            (<any>this).totalPossiblePointsPerQuestion = _data["totalPossiblePointsPerQuestion"];
            this.didCalculatePoints = _data["didCalculatePoints"];
        }
    }

    static fromJS(data: any): CommercialNitrogenFertilizerApplication {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialNitrogenFertilizerApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["totalPossiblePointsPerQuestion"] = this.totalPossiblePointsPerQuestion;
        data["didCalculatePoints"] = this.didCalculatePoints;
        return data; 
    }

    clone(): CommercialNitrogenFertilizerApplication {
        const json = this.toJSON();
        let result = new CommercialNitrogenFertilizerApplication();
        result.init(json);
        return result;
    }
}

export interface ICommercialNitrogenFertilizerApplication {
    label: string | undefined;
    points: number;
    totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;
}

export class ManureApplication implements IManureApplication {
    readonly label: string | undefined;
    points: number;
    readonly totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;

    constructor(data?: IManureApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            (<any>this).totalPossiblePointsPerQuestion = _data["totalPossiblePointsPerQuestion"];
            this.didCalculatePoints = _data["didCalculatePoints"];
        }
    }

    static fromJS(data: any): ManureApplication {
        data = typeof data === 'object' ? data : {};
        let result = new ManureApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["totalPossiblePointsPerQuestion"] = this.totalPossiblePointsPerQuestion;
        data["didCalculatePoints"] = this.didCalculatePoints;
        return data; 
    }

    clone(): ManureApplication {
        const json = this.toJSON();
        let result = new ManureApplication();
        result.init(json);
        return result;
    }
}

export interface IManureApplication {
    label: string | undefined;
    points: number;
    totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;
}

export class BiosolidsApplication implements IBiosolidsApplication {
    readonly label: string | undefined;
    points: number;
    readonly totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;

    constructor(data?: IBiosolidsApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            (<any>this).totalPossiblePointsPerQuestion = _data["totalPossiblePointsPerQuestion"];
            this.didCalculatePoints = _data["didCalculatePoints"];
        }
    }

    static fromJS(data: any): BiosolidsApplication {
        data = typeof data === 'object' ? data : {};
        let result = new BiosolidsApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["totalPossiblePointsPerQuestion"] = this.totalPossiblePointsPerQuestion;
        data["didCalculatePoints"] = this.didCalculatePoints;
        return data; 
    }

    clone(): BiosolidsApplication {
        const json = this.toJSON();
        let result = new BiosolidsApplication();
        result.init(json);
        return result;
    }
}

export interface IBiosolidsApplication {
    label: string | undefined;
    points: number;
    totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;
}

export class OtherOrganicSources implements IOtherOrganicSources {
    readonly label: string | undefined;
    points: number;
    readonly totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;

    constructor(data?: IOtherOrganicSources) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            (<any>this).totalPossiblePointsPerQuestion = _data["totalPossiblePointsPerQuestion"];
            this.didCalculatePoints = _data["didCalculatePoints"];
        }
    }

    static fromJS(data: any): OtherOrganicSources {
        data = typeof data === 'object' ? data : {};
        let result = new OtherOrganicSources();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["totalPossiblePointsPerQuestion"] = this.totalPossiblePointsPerQuestion;
        data["didCalculatePoints"] = this.didCalculatePoints;
        return data; 
    }

    clone(): OtherOrganicSources {
        const json = this.toJSON();
        let result = new OtherOrganicSources();
        result.init(json);
        return result;
    }
}

export interface IOtherOrganicSources {
    label: string | undefined;
    points: number;
    totalPossiblePointsPerQuestion: number;
    didCalculatePoints: boolean;
}

export class NutrientApplications implements INutrientApplications {
    readonly label: string | undefined;
    points: number;
    percentageScore: number;
    readonly numberOfCategories: number;
    readonly weightedPoints: number;
    commercialPhosphorusFertilizerApplication: CommercialPhosphorusFertilizerApplication;
    commercialNitrogenFertilizerApplication: CommercialNitrogenFertilizerApplication;
    manureApplication: ManureApplication;
    biosolidsApplication: BiosolidsApplication;
    otherOrganicSources: OtherOrganicSources;

    constructor(data?: INutrientApplications) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            this.percentageScore = _data["percentageScore"];
            (<any>this).numberOfCategories = _data["numberOfCategories"];
            (<any>this).weightedPoints = _data["weightedPoints"];
            this.commercialPhosphorusFertilizerApplication = _data["commercialPhosphorusFertilizerApplication"] ? CommercialPhosphorusFertilizerApplication.fromJS(_data["commercialPhosphorusFertilizerApplication"]) : <any>undefined;
            this.commercialNitrogenFertilizerApplication = _data["commercialNitrogenFertilizerApplication"] ? CommercialNitrogenFertilizerApplication.fromJS(_data["commercialNitrogenFertilizerApplication"]) : <any>undefined;
            this.manureApplication = _data["manureApplication"] ? ManureApplication.fromJS(_data["manureApplication"]) : <any>undefined;
            this.biosolidsApplication = _data["biosolidsApplication"] ? BiosolidsApplication.fromJS(_data["biosolidsApplication"]) : <any>undefined;
            this.otherOrganicSources = _data["otherOrganicSources"] ? OtherOrganicSources.fromJS(_data["otherOrganicSources"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NutrientApplications {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientApplications();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["percentageScore"] = this.percentageScore;
        data["numberOfCategories"] = this.numberOfCategories;
        data["weightedPoints"] = this.weightedPoints;
        data["commercialPhosphorusFertilizerApplication"] = this.commercialPhosphorusFertilizerApplication ? this.commercialPhosphorusFertilizerApplication.toJSON() : <any>undefined;
        data["commercialNitrogenFertilizerApplication"] = this.commercialNitrogenFertilizerApplication ? this.commercialNitrogenFertilizerApplication.toJSON() : <any>undefined;
        data["manureApplication"] = this.manureApplication ? this.manureApplication.toJSON() : <any>undefined;
        data["biosolidsApplication"] = this.biosolidsApplication ? this.biosolidsApplication.toJSON() : <any>undefined;
        data["otherOrganicSources"] = this.otherOrganicSources ? this.otherOrganicSources.toJSON() : <any>undefined;
        return data; 
    }

    clone(): NutrientApplications {
        const json = this.toJSON();
        let result = new NutrientApplications();
        result.init(json);
        return result;
    }
}

export interface INutrientApplications {
    label: string | undefined;
    points: number;
    percentageScore: number;
    numberOfCategories: number;
    weightedPoints: number;
    commercialPhosphorusFertilizerApplication: CommercialPhosphorusFertilizerApplication;
    commercialNitrogenFertilizerApplication: CommercialNitrogenFertilizerApplication;
    manureApplication: ManureApplication;
    biosolidsApplication: BiosolidsApplication;
    otherOrganicSources: OtherOrganicSources;
}

export class NutrientApplicationPlacement implements INutrientApplicationPlacement {
    readonly label: string | undefined;
    percentageScore: number;
    overallPercentageScore: number;
    readonly collapsed: boolean;
    nutrientApplications: NutrientApplications;

    constructor(data?: INutrientApplicationPlacement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.percentageScore = _data["percentageScore"];
            this.overallPercentageScore = _data["overallPercentageScore"];
            (<any>this).collapsed = _data["collapsed"];
            this.nutrientApplications = _data["nutrientApplications"] ? NutrientApplications.fromJS(_data["nutrientApplications"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NutrientApplicationPlacement {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientApplicationPlacement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["percentageScore"] = this.percentageScore;
        data["overallPercentageScore"] = this.overallPercentageScore;
        data["collapsed"] = this.collapsed;
        data["nutrientApplications"] = this.nutrientApplications ? this.nutrientApplications.toJSON() : <any>undefined;
        return data; 
    }

    clone(): NutrientApplicationPlacement {
        const json = this.toJSON();
        let result = new NutrientApplicationPlacement();
        result.init(json);
        return result;
    }
}

export interface INutrientApplicationPlacement {
    label: string | undefined;
    percentageScore: number;
    overallPercentageScore: number;
    collapsed: boolean;
    nutrientApplications: NutrientApplications;
}

export class Tillage implements ITillage {
    readonly label: string | undefined;
    points: number;
    readonly totalPossiblePointsPerQuestion: number;

    constructor(data?: ITillage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            (<any>this).totalPossiblePointsPerQuestion = _data["totalPossiblePointsPerQuestion"];
        }
    }

    static fromJS(data: any): Tillage {
        data = typeof data === 'object' ? data : {};
        let result = new Tillage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["totalPossiblePointsPerQuestion"] = this.totalPossiblePointsPerQuestion;
        return data; 
    }

    clone(): Tillage {
        const json = this.toJSON();
        let result = new Tillage();
        result.init(json);
        return result;
    }
}

export interface ITillage {
    label: string | undefined;
    points: number;
    totalPossiblePointsPerQuestion: number;
}

export class InFieldManagementTillage implements IInFieldManagementTillage {
    readonly label: string | undefined;
    points: number;
    percentageScore: number;
    readonly numberOfCategories: number;
    readonly weightedPoints: number;
    tillage: Tillage;

    constructor(data?: IInFieldManagementTillage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            this.percentageScore = _data["percentageScore"];
            (<any>this).numberOfCategories = _data["numberOfCategories"];
            (<any>this).weightedPoints = _data["weightedPoints"];
            this.tillage = _data["tillage"] ? Tillage.fromJS(_data["tillage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InFieldManagementTillage {
        data = typeof data === 'object' ? data : {};
        let result = new InFieldManagementTillage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["percentageScore"] = this.percentageScore;
        data["numberOfCategories"] = this.numberOfCategories;
        data["weightedPoints"] = this.weightedPoints;
        data["tillage"] = this.tillage ? this.tillage.toJSON() : <any>undefined;
        return data; 
    }

    clone(): InFieldManagementTillage {
        const json = this.toJSON();
        let result = new InFieldManagementTillage();
        result.init(json);
        return result;
    }
}

export interface IInFieldManagementTillage {
    label: string | undefined;
    points: number;
    percentageScore: number;
    numberOfCategories: number;
    weightedPoints: number;
    tillage: Tillage;
}

export class CoverCrops implements ICoverCrops {
    readonly label: string | undefined;
    points: number;
    readonly totalPossiblePointsPerQuestion: number;

    constructor(data?: ICoverCrops) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            (<any>this).totalPossiblePointsPerQuestion = _data["totalPossiblePointsPerQuestion"];
        }
    }

    static fromJS(data: any): CoverCrops {
        data = typeof data === 'object' ? data : {};
        let result = new CoverCrops();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["totalPossiblePointsPerQuestion"] = this.totalPossiblePointsPerQuestion;
        return data; 
    }

    clone(): CoverCrops {
        const json = this.toJSON();
        let result = new CoverCrops();
        result.init(json);
        return result;
    }
}

export interface ICoverCrops {
    label: string | undefined;
    points: number;
    totalPossiblePointsPerQuestion: number;
}

export class InFieldManagementCoverCrops implements IInFieldManagementCoverCrops {
    readonly label: string | undefined;
    points: number;
    percentageScore: number;
    readonly numberOfCategories: number;
    readonly weightedPoints: number;
    coverCrops: CoverCrops;

    constructor(data?: IInFieldManagementCoverCrops) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.points = _data["points"];
            this.percentageScore = _data["percentageScore"];
            (<any>this).numberOfCategories = _data["numberOfCategories"];
            (<any>this).weightedPoints = _data["weightedPoints"];
            this.coverCrops = _data["coverCrops"] ? CoverCrops.fromJS(_data["coverCrops"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InFieldManagementCoverCrops {
        data = typeof data === 'object' ? data : {};
        let result = new InFieldManagementCoverCrops();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["points"] = this.points;
        data["percentageScore"] = this.percentageScore;
        data["numberOfCategories"] = this.numberOfCategories;
        data["weightedPoints"] = this.weightedPoints;
        data["coverCrops"] = this.coverCrops ? this.coverCrops.toJSON() : <any>undefined;
        return data; 
    }

    clone(): InFieldManagementCoverCrops {
        const json = this.toJSON();
        let result = new InFieldManagementCoverCrops();
        result.init(json);
        return result;
    }
}

export interface IInFieldManagementCoverCrops {
    label: string | undefined;
    points: number;
    percentageScore: number;
    numberOfCategories: number;
    weightedPoints: number;
    coverCrops: CoverCrops;
}

export class InFieldManagement implements IInFieldManagement {
    readonly label: string | undefined;
    percentageScore: number;
    overallPercentageScore: number;
    readonly collapsed: boolean;
    inFieldManagementTillage: InFieldManagementTillage;
    inFieldManagementCoverCrops: InFieldManagementCoverCrops;

    constructor(data?: IInFieldManagement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.percentageScore = _data["percentageScore"];
            this.overallPercentageScore = _data["overallPercentageScore"];
            (<any>this).collapsed = _data["collapsed"];
            this.inFieldManagementTillage = _data["inFieldManagementTillage"] ? InFieldManagementTillage.fromJS(_data["inFieldManagementTillage"]) : <any>undefined;
            this.inFieldManagementCoverCrops = _data["inFieldManagementCoverCrops"] ? InFieldManagementCoverCrops.fromJS(_data["inFieldManagementCoverCrops"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InFieldManagement {
        data = typeof data === 'object' ? data : {};
        let result = new InFieldManagement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["percentageScore"] = this.percentageScore;
        data["overallPercentageScore"] = this.overallPercentageScore;
        data["collapsed"] = this.collapsed;
        data["inFieldManagementTillage"] = this.inFieldManagementTillage ? this.inFieldManagementTillage.toJSON() : <any>undefined;
        data["inFieldManagementCoverCrops"] = this.inFieldManagementCoverCrops ? this.inFieldManagementCoverCrops.toJSON() : <any>undefined;
        return data; 
    }

    clone(): InFieldManagement {
        const json = this.toJSON();
        let result = new InFieldManagement();
        result.init(json);
        return result;
    }
}

export interface IInFieldManagement {
    label: string | undefined;
    percentageScore: number;
    overallPercentageScore: number;
    collapsed: boolean;
    inFieldManagementTillage: InFieldManagementTillage;
    inFieldManagementCoverCrops: InFieldManagementCoverCrops;
}

export class StructuralPractices implements IStructuralPractices {
    readonly label: string | undefined;
    grassedWaterwaysPoints: number;
    gradeStabilizationStructuresPoints: number;
    blindInletsPoints: number;
    drainageWaterControlStructuresPoints: number;
    filterStripsOrBufferStripsPoints: number;
    wetlandsPoints: number;
    twoStageDitchOrNaturalStreamChannelRestorationPoints: number;
    denitrifyingBioreactorPoints: number;
    phosphorusRemovalBedPFilterPoints: number;

    constructor(data?: IStructuralPractices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.grassedWaterwaysPoints = _data["grassedWaterwaysPoints"];
            this.gradeStabilizationStructuresPoints = _data["gradeStabilizationStructuresPoints"];
            this.blindInletsPoints = _data["blindInletsPoints"];
            this.drainageWaterControlStructuresPoints = _data["drainageWaterControlStructuresPoints"];
            this.filterStripsOrBufferStripsPoints = _data["filterStripsOrBufferStripsPoints"];
            this.wetlandsPoints = _data["wetlandsPoints"];
            this.twoStageDitchOrNaturalStreamChannelRestorationPoints = _data["twoStageDitchOrNaturalStreamChannelRestorationPoints"];
            this.denitrifyingBioreactorPoints = _data["denitrifyingBioreactorPoints"];
            this.phosphorusRemovalBedPFilterPoints = _data["phosphorusRemovalBedPFilterPoints"];
        }
    }

    static fromJS(data: any): StructuralPractices {
        data = typeof data === 'object' ? data : {};
        let result = new StructuralPractices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["grassedWaterwaysPoints"] = this.grassedWaterwaysPoints;
        data["gradeStabilizationStructuresPoints"] = this.gradeStabilizationStructuresPoints;
        data["blindInletsPoints"] = this.blindInletsPoints;
        data["drainageWaterControlStructuresPoints"] = this.drainageWaterControlStructuresPoints;
        data["filterStripsOrBufferStripsPoints"] = this.filterStripsOrBufferStripsPoints;
        data["wetlandsPoints"] = this.wetlandsPoints;
        data["twoStageDitchOrNaturalStreamChannelRestorationPoints"] = this.twoStageDitchOrNaturalStreamChannelRestorationPoints;
        data["denitrifyingBioreactorPoints"] = this.denitrifyingBioreactorPoints;
        data["phosphorusRemovalBedPFilterPoints"] = this.phosphorusRemovalBedPFilterPoints;
        return data; 
    }

    clone(): StructuralPractices {
        const json = this.toJSON();
        let result = new StructuralPractices();
        result.init(json);
        return result;
    }
}

export interface IStructuralPractices {
    label: string | undefined;
    grassedWaterwaysPoints: number;
    gradeStabilizationStructuresPoints: number;
    blindInletsPoints: number;
    drainageWaterControlStructuresPoints: number;
    filterStripsOrBufferStripsPoints: number;
    wetlandsPoints: number;
    twoStageDitchOrNaturalStreamChannelRestorationPoints: number;
    denitrifyingBioreactorPoints: number;
    phosphorusRemovalBedPFilterPoints: number;
}

export class StructuralPracticesBonus implements IStructuralPracticesBonus {
    readonly label: string | undefined;
    overallPercentageScore: number;
    bonusPoints: number;
    readonly collapsed: boolean;
    readonly capPoints: number;
    structuralPractices: StructuralPractices;

    constructor(data?: IStructuralPracticesBonus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).label = _data["label"];
            this.overallPercentageScore = _data["overallPercentageScore"];
            this.bonusPoints = _data["bonusPoints"];
            (<any>this).collapsed = _data["collapsed"];
            (<any>this).capPoints = _data["capPoints"];
            this.structuralPractices = _data["structuralPractices"] ? StructuralPractices.fromJS(_data["structuralPractices"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StructuralPracticesBonus {
        data = typeof data === 'object' ? data : {};
        let result = new StructuralPracticesBonus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["overallPercentageScore"] = this.overallPercentageScore;
        data["bonusPoints"] = this.bonusPoints;
        data["collapsed"] = this.collapsed;
        data["capPoints"] = this.capPoints;
        data["structuralPractices"] = this.structuralPractices ? this.structuralPractices.toJSON() : <any>undefined;
        return data; 
    }

    clone(): StructuralPracticesBonus {
        const json = this.toJSON();
        let result = new StructuralPracticesBonus();
        result.init(json);
        return result;
    }
}

export interface IStructuralPracticesBonus {
    label: string | undefined;
    overallPercentageScore: number;
    bonusPoints: number;
    collapsed: boolean;
    capPoints: number;
    structuralPractices: StructuralPractices;
}

export class CertificationScore implements ICertificationScore {
    points: number;
    percentageScore: number;
    averagePercentageScore: number;
    readonly numberOfCategories: number;
    readonly weightedPoints: number;
    soilTestFrequency: SoilTestFrequency;
    soilTestIntensity: SoilTestIntensity;
    nutrientApplicationRate: NutrientApplicationRate;
    nutrientApplicationPlacement: NutrientApplicationPlacement;
    inFieldManagement: InFieldManagement;
    structuralPracticesBonus: StructuralPracticesBonus;

    constructor(data?: ICertificationScore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.points = _data["points"];
            this.percentageScore = _data["percentageScore"];
            this.averagePercentageScore = _data["averagePercentageScore"];
            (<any>this).numberOfCategories = _data["numberOfCategories"];
            (<any>this).weightedPoints = _data["weightedPoints"];
            this.soilTestFrequency = _data["soilTestFrequency"] ? SoilTestFrequency.fromJS(_data["soilTestFrequency"]) : <any>undefined;
            this.soilTestIntensity = _data["soilTestIntensity"] ? SoilTestIntensity.fromJS(_data["soilTestIntensity"]) : <any>undefined;
            this.nutrientApplicationRate = _data["nutrientApplicationRate"] ? NutrientApplicationRate.fromJS(_data["nutrientApplicationRate"]) : <any>undefined;
            this.nutrientApplicationPlacement = _data["nutrientApplicationPlacement"] ? NutrientApplicationPlacement.fromJS(_data["nutrientApplicationPlacement"]) : <any>undefined;
            this.inFieldManagement = _data["inFieldManagement"] ? InFieldManagement.fromJS(_data["inFieldManagement"]) : <any>undefined;
            this.structuralPracticesBonus = _data["structuralPracticesBonus"] ? StructuralPracticesBonus.fromJS(_data["structuralPracticesBonus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CertificationScore {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["points"] = this.points;
        data["percentageScore"] = this.percentageScore;
        data["averagePercentageScore"] = this.averagePercentageScore;
        data["numberOfCategories"] = this.numberOfCategories;
        data["weightedPoints"] = this.weightedPoints;
        data["soilTestFrequency"] = this.soilTestFrequency ? this.soilTestFrequency.toJSON() : <any>undefined;
        data["soilTestIntensity"] = this.soilTestIntensity ? this.soilTestIntensity.toJSON() : <any>undefined;
        data["nutrientApplicationRate"] = this.nutrientApplicationRate ? this.nutrientApplicationRate.toJSON() : <any>undefined;
        data["nutrientApplicationPlacement"] = this.nutrientApplicationPlacement ? this.nutrientApplicationPlacement.toJSON() : <any>undefined;
        data["inFieldManagement"] = this.inFieldManagement ? this.inFieldManagement.toJSON() : <any>undefined;
        data["structuralPracticesBonus"] = this.structuralPracticesBonus ? this.structuralPracticesBonus.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CertificationScore {
        const json = this.toJSON();
        let result = new CertificationScore();
        result.init(json);
        return result;
    }
}

export interface ICertificationScore {
    points: number;
    percentageScore: number;
    averagePercentageScore: number;
    numberOfCategories: number;
    weightedPoints: number;
    soilTestFrequency: SoilTestFrequency;
    soilTestIntensity: SoilTestIntensity;
    nutrientApplicationRate: NutrientApplicationRate;
    nutrientApplicationPlacement: NutrientApplicationPlacement;
    inFieldManagement: InFieldManagement;
    structuralPracticesBonus: StructuralPracticesBonus;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string | undefined;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data; 
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string | undefined;
}

export class CostShareDto implements ICostShareDto {
    name: string | undefined;
    id: number;

    constructor(data?: ICostShareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CostShareDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostShareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): CostShareDto {
        const json = this.toJSON();
        let result = new CostShareDto();
        result.init(json);
        return result;
    }
}

export interface ICostShareDto {
    name: string | undefined;
    id: number;
}

export class CountyDto implements ICountyDto {
    name: string | undefined;
    id: number;

    constructor(data?: ICountyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CountyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): CountyDto {
        const json = this.toJSON();
        let result = new CountyDto();
        result.init(json);
        return result;
    }
}

export interface ICountyDto {
    name: string | undefined;
    id: number;
}

export class CropDto implements ICropDto {
    name: string | undefined;
    isDefault: boolean;
    id: number;

    constructor(data?: ICropDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CropDto {
        data = typeof data === 'object' ? data : {};
        let result = new CropDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["id"] = this.id;
        return data; 
    }

    clone(): CropDto {
        const json = this.toJSON();
        let result = new CropDto();
        result.init(json);
        return result;
    }
}

export interface ICropDto {
    name: string | undefined;
    isDefault: boolean;
    id: number;
}

export class FarmerRegistrationCompleteDto implements IFarmerRegistrationCompleteDto {
    completeFarmers: number;
    totalFarmers: number;

    constructor(data?: IFarmerRegistrationCompleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completeFarmers = _data["completeFarmers"];
            this.totalFarmers = _data["totalFarmers"];
        }
    }

    static fromJS(data: any): FarmerRegistrationCompleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerRegistrationCompleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completeFarmers"] = this.completeFarmers;
        data["totalFarmers"] = this.totalFarmers;
        return data; 
    }

    clone(): FarmerRegistrationCompleteDto {
        const json = this.toJSON();
        let result = new FarmerRegistrationCompleteDto();
        result.init(json);
        return result;
    }
}

export interface IFarmerRegistrationCompleteDto {
    completeFarmers: number;
    totalFarmers: number;
}

export class Int32DecimalNullableGraphData implements IInt32DecimalNullableGraphData {
    key: number;
    value: number | undefined;

    constructor(data?: IInt32DecimalNullableGraphData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Int32DecimalNullableGraphData {
        data = typeof data === 'object' ? data : {};
        let result = new Int32DecimalNullableGraphData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }

    clone(): Int32DecimalNullableGraphData {
        const json = this.toJSON();
        let result = new Int32DecimalNullableGraphData();
        result.init(json);
        return result;
    }
}

export interface IInt32DecimalNullableGraphData {
    key: number;
    value: number | undefined;
}

export class StringInt32Int32GraphData implements IStringInt32Int32GraphData {
    series: string | undefined;
    key: number;
    value: number;

    constructor(data?: IStringInt32Int32GraphData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.series = _data["series"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StringInt32Int32GraphData {
        data = typeof data === 'object' ? data : {};
        let result = new StringInt32Int32GraphData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["series"] = this.series;
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }

    clone(): StringInt32Int32GraphData {
        const json = this.toJSON();
        let result = new StringInt32Int32GraphData();
        result.init(json);
        return result;
    }
}

export interface IStringInt32Int32GraphData {
    series: string | undefined;
    key: number;
    value: number;
}

export class CertificationScoreDto implements ICertificationScoreDto {
    scores: Int32DecimalNullableGraphData[] | undefined;
    statuses: StringInt32Int32GraphData[] | undefined;
    acres: Int32DecimalNullableGraphData[] | undefined;

    constructor(data?: ICertificationScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scores"])) {
                this.scores = [] as any;
                for (let item of _data["scores"])
                    this.scores.push(Int32DecimalNullableGraphData.fromJS(item));
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses.push(StringInt32Int32GraphData.fromJS(item));
            }
            if (Array.isArray(_data["acres"])) {
                this.acres = [] as any;
                for (let item of _data["acres"])
                    this.acres.push(Int32DecimalNullableGraphData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CertificationScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scores)) {
            data["scores"] = [];
            for (let item of this.scores)
                data["scores"].push(item.toJSON());
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        if (Array.isArray(this.acres)) {
            data["acres"] = [];
            for (let item of this.acres)
                data["acres"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CertificationScoreDto {
        const json = this.toJSON();
        let result = new CertificationScoreDto();
        result.init(json);
        return result;
    }
}

export interface ICertificationScoreDto {
    scores: Int32DecimalNullableGraphData[] | undefined;
    statuses: StringInt32Int32GraphData[] | undefined;
    acres: Int32DecimalNullableGraphData[] | undefined;
}

export class ExportRequestDto implements IExportRequestDto {
    entity: string | undefined;
    columnNames: string[] | undefined;
    data: string[][] | undefined;

    constructor(data?: IExportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entity = _data["entity"];
            if (Array.isArray(_data["columnNames"])) {
                this.columnNames = [] as any;
                for (let item of _data["columnNames"])
                    this.columnNames.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(item);
            }
        }
    }

    static fromJS(data: any): ExportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity;
        if (Array.isArray(this.columnNames)) {
            data["columnNames"] = [];
            for (let item of this.columnNames)
                data["columnNames"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data; 
    }

    clone(): ExportRequestDto {
        const json = this.toJSON();
        let result = new ExportRequestDto();
        result.init(json);
        return result;
    }
}

export interface IExportRequestDto {
    entity: string | undefined;
    columnNames: string[] | undefined;
    data: string[][] | undefined;
}

export class FarmerCostShareDto implements IFarmerCostShareDto {
    farmerId: number;
    costShareId: number;
    costShareName: string | undefined;
    id: number;

    constructor(data?: IFarmerCostShareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.costShareId = _data["costShareId"];
            this.costShareName = _data["costShareName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerCostShareDto {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerCostShareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["costShareId"] = this.costShareId;
        data["costShareName"] = this.costShareName;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerCostShareDto {
        const json = this.toJSON();
        let result = new FarmerCostShareDto();
        result.init(json);
        return result;
    }
}

export interface IFarmerCostShareDto {
    farmerId: number;
    costShareId: number;
    costShareName: string | undefined;
    id: number;
}

export class UserToken implements IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;
}

export class UserLogin implements IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    providerKey: string | undefined;
    id: number;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    providerKey: string | undefined;
    id: number;
}

export class UserRole implements IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserClaim implements IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string | undefined;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string | undefined;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Setting implements ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string | undefined;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string | undefined;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class User implements IUser {
    firstName: string | undefined;
    lastName: string | undefined;
    normalizedUserName: string | undefined;
    normalizedEmailAddress: string | undefined;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string | undefined;
    tenantId: number | undefined;
    emailAddress: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    readonly fullName: string | undefined;
    password: string | undefined;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    firstName: string | undefined;
    lastName: string | undefined;
    normalizedUserName: string | undefined;
    normalizedEmailAddress: string | undefined;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string | undefined;
    tenantId: number | undefined;
    emailAddress: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    password: string | undefined;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class County implements ICounty {
    name: string | undefined;
    id: number;

    constructor(data?: ICounty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): County {
        data = typeof data === 'object' ? data : {};
        let result = new County();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): County {
        const json = this.toJSON();
        let result = new County();
        result.init(json);
        return result;
    }
}

export interface ICounty {
    name: string | undefined;
    id: number;
}

export class FarmerCounty implements IFarmerCounty {
    farmerId: number;
    farmer: Farmer;
    countyId: number;
    county: County;
    id: number;

    constructor(data?: IFarmerCounty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.farmer = _data["farmer"] ? Farmer.fromJS(_data["farmer"]) : <any>undefined;
            this.countyId = _data["countyId"];
            this.county = _data["county"] ? County.fromJS(_data["county"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerCounty {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerCounty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["farmer"] = this.farmer ? this.farmer.toJSON() : <any>undefined;
        data["countyId"] = this.countyId;
        data["county"] = this.county ? this.county.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerCounty {
        const json = this.toJSON();
        let result = new FarmerCounty();
        result.init(json);
        return result;
    }
}

export interface IFarmerCounty {
    farmerId: number;
    farmer: Farmer;
    countyId: number;
    county: County;
    id: number;
}

export class Crop implements ICrop {
    name: string | undefined;
    isDefault: boolean;
    id: number;

    constructor(data?: ICrop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Crop {
        data = typeof data === 'object' ? data : {};
        let result = new Crop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["id"] = this.id;
        return data; 
    }

    clone(): Crop {
        const json = this.toJSON();
        let result = new Crop();
        result.init(json);
        return result;
    }
}

export interface ICrop {
    name: string | undefined;
    isDefault: boolean;
    id: number;
}

export class FarmerCropQuantity implements IFarmerCropQuantity {
    farmerId: number;
    farmer: Farmer;
    cropId: number;
    crop: Crop;
    quantity: number | undefined;
    id: number;

    constructor(data?: IFarmerCropQuantity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.farmer = _data["farmer"] ? Farmer.fromJS(_data["farmer"]) : <any>undefined;
            this.cropId = _data["cropId"];
            this.crop = _data["crop"] ? Crop.fromJS(_data["crop"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerCropQuantity {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerCropQuantity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["farmer"] = this.farmer ? this.farmer.toJSON() : <any>undefined;
        data["cropId"] = this.cropId;
        data["crop"] = this.crop ? this.crop.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerCropQuantity {
        const json = this.toJSON();
        let result = new FarmerCropQuantity();
        result.init(json);
        return result;
    }
}

export interface IFarmerCropQuantity {
    farmerId: number;
    farmer: Farmer;
    cropId: number;
    crop: Crop;
    quantity: number | undefined;
    id: number;
}

export class NutrientSource implements INutrientSource {
    name: string | undefined;
    sort: number;
    id: number;

    constructor(data?: INutrientSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sort = _data["sort"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NutrientSource {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sort"] = this.sort;
        data["id"] = this.id;
        return data; 
    }

    clone(): NutrientSource {
        const json = this.toJSON();
        let result = new NutrientSource();
        result.init(json);
        return result;
    }
}

export interface INutrientSource {
    name: string | undefined;
    sort: number;
    id: number;
}

export class FarmerNutrientSourceQuantity implements IFarmerNutrientSourceQuantity {
    farmerId: number;
    farmer: Farmer;
    nutrientSourceId: number;
    nutrientSource: NutrientSource;
    ownedQuantity: number | undefined;
    rentedQuantity: number | undefined;
    id: number;

    constructor(data?: IFarmerNutrientSourceQuantity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.farmer = _data["farmer"] ? Farmer.fromJS(_data["farmer"]) : <any>undefined;
            this.nutrientSourceId = _data["nutrientSourceId"];
            this.nutrientSource = _data["nutrientSource"] ? NutrientSource.fromJS(_data["nutrientSource"]) : <any>undefined;
            this.ownedQuantity = _data["ownedQuantity"];
            this.rentedQuantity = _data["rentedQuantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerNutrientSourceQuantity {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerNutrientSourceQuantity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["farmer"] = this.farmer ? this.farmer.toJSON() : <any>undefined;
        data["nutrientSourceId"] = this.nutrientSourceId;
        data["nutrientSource"] = this.nutrientSource ? this.nutrientSource.toJSON() : <any>undefined;
        data["ownedQuantity"] = this.ownedQuantity;
        data["rentedQuantity"] = this.rentedQuantity;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerNutrientSourceQuantity {
        const json = this.toJSON();
        let result = new FarmerNutrientSourceQuantity();
        result.init(json);
        return result;
    }
}

export interface IFarmerNutrientSourceQuantity {
    farmerId: number;
    farmer: Farmer;
    nutrientSourceId: number;
    nutrientSource: NutrientSource;
    ownedQuantity: number | undefined;
    rentedQuantity: number | undefined;
    id: number;
}

export class NutrientRecommendation implements INutrientRecommendation {
    name: string | undefined;
    isFullService: boolean;
    id: number;

    constructor(data?: INutrientRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isFullService = _data["isFullService"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NutrientRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isFullService"] = this.isFullService;
        data["id"] = this.id;
        return data; 
    }

    clone(): NutrientRecommendation {
        const json = this.toJSON();
        let result = new NutrientRecommendation();
        result.init(json);
        return result;
    }
}

export interface INutrientRecommendation {
    name: string | undefined;
    isFullService: boolean;
    id: number;
}

export class FarmerNutrientRecommendationQuantity implements IFarmerNutrientRecommendationQuantity {
    farmerId: number;
    farmer: Farmer;
    nutrientRecommendationId: number;
    nutrientRecommendation: NutrientRecommendation;
    ownedQuantity: number | undefined;
    rentedQuantity: number | undefined;
    id: number;

    constructor(data?: IFarmerNutrientRecommendationQuantity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.farmer = _data["farmer"] ? Farmer.fromJS(_data["farmer"]) : <any>undefined;
            this.nutrientRecommendationId = _data["nutrientRecommendationId"];
            this.nutrientRecommendation = _data["nutrientRecommendation"] ? NutrientRecommendation.fromJS(_data["nutrientRecommendation"]) : <any>undefined;
            this.ownedQuantity = _data["ownedQuantity"];
            this.rentedQuantity = _data["rentedQuantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerNutrientRecommendationQuantity {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerNutrientRecommendationQuantity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["farmer"] = this.farmer ? this.farmer.toJSON() : <any>undefined;
        data["nutrientRecommendationId"] = this.nutrientRecommendationId;
        data["nutrientRecommendation"] = this.nutrientRecommendation ? this.nutrientRecommendation.toJSON() : <any>undefined;
        data["ownedQuantity"] = this.ownedQuantity;
        data["rentedQuantity"] = this.rentedQuantity;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerNutrientRecommendationQuantity {
        const json = this.toJSON();
        let result = new FarmerNutrientRecommendationQuantity();
        result.init(json);
        return result;
    }
}

export interface IFarmerNutrientRecommendationQuantity {
    farmerId: number;
    farmer: Farmer;
    nutrientRecommendationId: number;
    nutrientRecommendation: NutrientRecommendation;
    ownedQuantity: number | undefined;
    rentedQuantity: number | undefined;
    id: number;
}

export class NMPType implements INMPType {
    name: string | undefined;
    isFullService: boolean;
    id: number;

    constructor(data?: INMPType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isFullService = _data["isFullService"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NMPType {
        data = typeof data === 'object' ? data : {};
        let result = new NMPType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isFullService"] = this.isFullService;
        data["id"] = this.id;
        return data; 
    }

    clone(): NMPType {
        const json = this.toJSON();
        let result = new NMPType();
        result.init(json);
        return result;
    }
}

export interface INMPType {
    name: string | undefined;
    isFullService: boolean;
    id: number;
}

export class ManureStorageSource implements IManureStorageSource {
    name: string | undefined;
    id: number;

    constructor(data?: IManureStorageSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ManureStorageSource {
        data = typeof data === 'object' ? data : {};
        let result = new ManureStorageSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): ManureStorageSource {
        const json = this.toJSON();
        let result = new ManureStorageSource();
        result.init(json);
        return result;
    }
}

export interface IManureStorageSource {
    name: string | undefined;
    id: number;
}

export class ManureStorageDuration implements IManureStorageDuration {
    name: string | undefined;
    id: number;

    constructor(data?: IManureStorageDuration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ManureStorageDuration {
        data = typeof data === 'object' ? data : {};
        let result = new ManureStorageDuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): ManureStorageDuration {
        const json = this.toJSON();
        let result = new ManureStorageDuration();
        result.init(json);
        return result;
    }
}

export interface IManureStorageDuration {
    name: string | undefined;
    id: number;
}

export class ManureStorageType implements IManureStorageType {
    name: string | undefined;
    id: number;

    constructor(data?: IManureStorageType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ManureStorageType {
        data = typeof data === 'object' ? data : {};
        let result = new ManureStorageType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): ManureStorageType {
        const json = this.toJSON();
        let result = new ManureStorageType();
        result.init(json);
        return result;
    }
}

export interface IManureStorageType {
    name: string | undefined;
    id: number;
}

export class FarmerManureStorage implements IFarmerManureStorage {
    farmerId: number;
    farmer: Farmer;
    manureStorageSourceId: number;
    manureStorageSource: ManureStorageSource;
    manureStorageDurationId: number;
    manureStorageDuration: ManureStorageDuration;
    manureStorageTypeId: number;
    manureStorageType: ManureStorageType;
    id: number;

    constructor(data?: IFarmerManureStorage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.farmer = _data["farmer"] ? Farmer.fromJS(_data["farmer"]) : <any>undefined;
            this.manureStorageSourceId = _data["manureStorageSourceId"];
            this.manureStorageSource = _data["manureStorageSource"] ? ManureStorageSource.fromJS(_data["manureStorageSource"]) : <any>undefined;
            this.manureStorageDurationId = _data["manureStorageDurationId"];
            this.manureStorageDuration = _data["manureStorageDuration"] ? ManureStorageDuration.fromJS(_data["manureStorageDuration"]) : <any>undefined;
            this.manureStorageTypeId = _data["manureStorageTypeId"];
            this.manureStorageType = _data["manureStorageType"] ? ManureStorageType.fromJS(_data["manureStorageType"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerManureStorage {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerManureStorage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["farmer"] = this.farmer ? this.farmer.toJSON() : <any>undefined;
        data["manureStorageSourceId"] = this.manureStorageSourceId;
        data["manureStorageSource"] = this.manureStorageSource ? this.manureStorageSource.toJSON() : <any>undefined;
        data["manureStorageDurationId"] = this.manureStorageDurationId;
        data["manureStorageDuration"] = this.manureStorageDuration ? this.manureStorageDuration.toJSON() : <any>undefined;
        data["manureStorageTypeId"] = this.manureStorageTypeId;
        data["manureStorageType"] = this.manureStorageType ? this.manureStorageType.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerManureStorage {
        const json = this.toJSON();
        let result = new FarmerManureStorage();
        result.init(json);
        return result;
    }
}

export interface IFarmerManureStorage {
    farmerId: number;
    farmer: Farmer;
    manureStorageSourceId: number;
    manureStorageSource: ManureStorageSource;
    manureStorageDurationId: number;
    manureStorageDuration: ManureStorageDuration;
    manureStorageTypeId: number;
    manureStorageType: ManureStorageType;
    id: number;
}

export class Watershed implements IWatershed {
    name: string | undefined;
    code: string | undefined;
    id: number;

    constructor(data?: IWatershed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Watershed {
        data = typeof data === 'object' ? data : {};
        let result = new Watershed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data; 
    }

    clone(): Watershed {
        const json = this.toJSON();
        let result = new Watershed();
        result.init(json);
        return result;
    }
}

export interface IWatershed {
    name: string | undefined;
    code: string | undefined;
    id: number;
}

export class FarmerWatershed implements IFarmerWatershed {
    farmerId: number;
    farmer: Farmer;
    watershedId: number;
    watershed: Watershed;
    id: number;

    constructor(data?: IFarmerWatershed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.farmer = _data["farmer"] ? Farmer.fromJS(_data["farmer"]) : <any>undefined;
            this.watershedId = _data["watershedId"];
            this.watershed = _data["watershed"] ? Watershed.fromJS(_data["watershed"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerWatershed {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerWatershed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["farmer"] = this.farmer ? this.farmer.toJSON() : <any>undefined;
        data["watershedId"] = this.watershedId;
        data["watershed"] = this.watershed ? this.watershed.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerWatershed {
        const json = this.toJSON();
        let result = new FarmerWatershed();
        result.init(json);
        return result;
    }
}

export interface IFarmerWatershed {
    farmerId: number;
    farmer: Farmer;
    watershedId: number;
    watershed: Watershed;
    id: number;
}

export class CCertificationStatus implements ICCertificationStatus {
    id: CCertificationStatusEnum;
    name: string | undefined;

    constructor(data?: ICCertificationStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CCertificationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CCertificationStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): CCertificationStatus {
        const json = this.toJSON();
        let result = new CCertificationStatus();
        result.init(json);
        return result;
    }
}

export interface ICCertificationStatus {
    id: CCertificationStatusEnum;
    name: string | undefined;
}

export class CCertification implements ICCertification {
    farmerId: number;
    statusId: CCertificationStatusEnum;
    status: CCertificationStatus;
    year: number;
    isActive: boolean;
    farmer: Farmer;
    score: number | undefined;
    isPassing: boolean | undefined;
    completionMessage: string | undefined;
    ownedAcres: number | undefined;
    rentedAcres: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICCertification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? CCertificationStatus.fromJS(_data["status"]) : <any>undefined;
            this.year = _data["year"];
            this.isActive = _data["isActive"];
            this.farmer = _data["farmer"] ? Farmer.fromJS(_data["farmer"]) : <any>undefined;
            this.score = _data["score"];
            this.isPassing = _data["isPassing"];
            this.completionMessage = _data["completionMessage"];
            this.ownedAcres = _data["ownedAcres"];
            this.rentedAcres = _data["rentedAcres"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CCertification {
        data = typeof data === 'object' ? data : {};
        let result = new CCertification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["year"] = this.year;
        data["isActive"] = this.isActive;
        data["farmer"] = this.farmer ? this.farmer.toJSON() : <any>undefined;
        data["score"] = this.score;
        data["isPassing"] = this.isPassing;
        data["completionMessage"] = this.completionMessage;
        data["ownedAcres"] = this.ownedAcres;
        data["rentedAcres"] = this.rentedAcres;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CCertification {
        const json = this.toJSON();
        let result = new CCertification();
        result.init(json);
        return result;
    }
}

export interface ICCertification {
    farmerId: number;
    statusId: CCertificationStatusEnum;
    status: CCertificationStatus;
    year: number;
    isActive: boolean;
    farmer: Farmer;
    score: number | undefined;
    isPassing: boolean | undefined;
    completionMessage: string | undefined;
    ownedAcres: number | undefined;
    rentedAcres: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Farmer implements IFarmer {
    userId: number;
    user: User;
    farmName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    counties: FarmerCounty[] | undefined;
    ownedAcres: number | undefined;
    rentedAcres: number | undefined;
    cropQuantities: FarmerCropQuantity[] | undefined;
    nutrientSourceQuantities: FarmerNutrientSourceQuantity[] | undefined;
    nutrientRecommendationQuantities: FarmerNutrientRecommendationQuantity[] | undefined;
    nmpComplete: boolean | undefined;
    nmpTypeId: number | undefined;
    nmpType: NMPType;
    nmpHasBeenStarted: boolean | undefined;
    nmpCompletionDate: moment.Moment | undefined;
    nmpAcreageQuantity: number | undefined;
    factComplete: boolean | undefined;
    factCompletionDate: moment.Moment | undefined;
    nutrientApplication: number | undefined;
    sensitiveAreas: boolean | undefined;
    manureStorages: FarmerManureStorage[] | undefined;
    costShares: FarmerCostShare[] | undefined;
    watersheds: FarmerWatershed[] | undefined;
    cCertifications: CCertification[] | undefined;
    profileMissingFields: string | undefined;
    profileErrors: string | undefined;
    lastModifierUser: User;
    infoRepresentsEntireFarmingOperation: boolean | undefined;
    infoSubjectToAuditByIndependentAuditors: boolean | undefined;
    infoFairAndAccurateToBestAbility: boolean | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IFarmer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.farmName = _data["farmName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            if (Array.isArray(_data["counties"])) {
                this.counties = [] as any;
                for (let item of _data["counties"])
                    this.counties.push(FarmerCounty.fromJS(item));
            }
            this.ownedAcres = _data["ownedAcres"];
            this.rentedAcres = _data["rentedAcres"];
            if (Array.isArray(_data["cropQuantities"])) {
                this.cropQuantities = [] as any;
                for (let item of _data["cropQuantities"])
                    this.cropQuantities.push(FarmerCropQuantity.fromJS(item));
            }
            if (Array.isArray(_data["nutrientSourceQuantities"])) {
                this.nutrientSourceQuantities = [] as any;
                for (let item of _data["nutrientSourceQuantities"])
                    this.nutrientSourceQuantities.push(FarmerNutrientSourceQuantity.fromJS(item));
            }
            if (Array.isArray(_data["nutrientRecommendationQuantities"])) {
                this.nutrientRecommendationQuantities = [] as any;
                for (let item of _data["nutrientRecommendationQuantities"])
                    this.nutrientRecommendationQuantities.push(FarmerNutrientRecommendationQuantity.fromJS(item));
            }
            this.nmpComplete = _data["nmpComplete"];
            this.nmpTypeId = _data["nmpTypeId"];
            this.nmpType = _data["nmpType"] ? NMPType.fromJS(_data["nmpType"]) : <any>undefined;
            this.nmpHasBeenStarted = _data["nmpHasBeenStarted"];
            this.nmpCompletionDate = _data["nmpCompletionDate"] ? moment(_data["nmpCompletionDate"].toString()) : <any>undefined;
            this.nmpAcreageQuantity = _data["nmpAcreageQuantity"];
            this.factComplete = _data["factComplete"];
            this.factCompletionDate = _data["factCompletionDate"] ? moment(_data["factCompletionDate"].toString()) : <any>undefined;
            this.nutrientApplication = _data["nutrientApplication"];
            this.sensitiveAreas = _data["sensitiveAreas"];
            if (Array.isArray(_data["manureStorages"])) {
                this.manureStorages = [] as any;
                for (let item of _data["manureStorages"])
                    this.manureStorages.push(FarmerManureStorage.fromJS(item));
            }
            if (Array.isArray(_data["costShares"])) {
                this.costShares = [] as any;
                for (let item of _data["costShares"])
                    this.costShares.push(FarmerCostShare.fromJS(item));
            }
            if (Array.isArray(_data["watersheds"])) {
                this.watersheds = [] as any;
                for (let item of _data["watersheds"])
                    this.watersheds.push(FarmerWatershed.fromJS(item));
            }
            if (Array.isArray(_data["cCertifications"])) {
                this.cCertifications = [] as any;
                for (let item of _data["cCertifications"])
                    this.cCertifications.push(CCertification.fromJS(item));
            }
            this.profileMissingFields = _data["profileMissingFields"];
            this.profileErrors = _data["profileErrors"];
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.infoRepresentsEntireFarmingOperation = _data["infoRepresentsEntireFarmingOperation"];
            this.infoSubjectToAuditByIndependentAuditors = _data["infoSubjectToAuditByIndependentAuditors"];
            this.infoFairAndAccurateToBestAbility = _data["infoFairAndAccurateToBestAbility"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Farmer {
        data = typeof data === 'object' ? data : {};
        let result = new Farmer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["farmName"] = this.farmName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        if (Array.isArray(this.counties)) {
            data["counties"] = [];
            for (let item of this.counties)
                data["counties"].push(item.toJSON());
        }
        data["ownedAcres"] = this.ownedAcres;
        data["rentedAcres"] = this.rentedAcres;
        if (Array.isArray(this.cropQuantities)) {
            data["cropQuantities"] = [];
            for (let item of this.cropQuantities)
                data["cropQuantities"].push(item.toJSON());
        }
        if (Array.isArray(this.nutrientSourceQuantities)) {
            data["nutrientSourceQuantities"] = [];
            for (let item of this.nutrientSourceQuantities)
                data["nutrientSourceQuantities"].push(item.toJSON());
        }
        if (Array.isArray(this.nutrientRecommendationQuantities)) {
            data["nutrientRecommendationQuantities"] = [];
            for (let item of this.nutrientRecommendationQuantities)
                data["nutrientRecommendationQuantities"].push(item.toJSON());
        }
        data["nmpComplete"] = this.nmpComplete;
        data["nmpTypeId"] = this.nmpTypeId;
        data["nmpType"] = this.nmpType ? this.nmpType.toJSON() : <any>undefined;
        data["nmpHasBeenStarted"] = this.nmpHasBeenStarted;
        data["nmpCompletionDate"] = this.nmpCompletionDate ? this.nmpCompletionDate.toISOString() : <any>undefined;
        data["nmpAcreageQuantity"] = this.nmpAcreageQuantity;
        data["factComplete"] = this.factComplete;
        data["factCompletionDate"] = this.factCompletionDate ? this.factCompletionDate.toISOString() : <any>undefined;
        data["nutrientApplication"] = this.nutrientApplication;
        data["sensitiveAreas"] = this.sensitiveAreas;
        if (Array.isArray(this.manureStorages)) {
            data["manureStorages"] = [];
            for (let item of this.manureStorages)
                data["manureStorages"].push(item.toJSON());
        }
        if (Array.isArray(this.costShares)) {
            data["costShares"] = [];
            for (let item of this.costShares)
                data["costShares"].push(item.toJSON());
        }
        if (Array.isArray(this.watersheds)) {
            data["watersheds"] = [];
            for (let item of this.watersheds)
                data["watersheds"].push(item.toJSON());
        }
        if (Array.isArray(this.cCertifications)) {
            data["cCertifications"] = [];
            for (let item of this.cCertifications)
                data["cCertifications"].push(item.toJSON());
        }
        data["profileMissingFields"] = this.profileMissingFields;
        data["profileErrors"] = this.profileErrors;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["infoRepresentsEntireFarmingOperation"] = this.infoRepresentsEntireFarmingOperation;
        data["infoSubjectToAuditByIndependentAuditors"] = this.infoSubjectToAuditByIndependentAuditors;
        data["infoFairAndAccurateToBestAbility"] = this.infoFairAndAccurateToBestAbility;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Farmer {
        const json = this.toJSON();
        let result = new Farmer();
        result.init(json);
        return result;
    }
}

export interface IFarmer {
    userId: number;
    user: User;
    farmName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    counties: FarmerCounty[] | undefined;
    ownedAcres: number | undefined;
    rentedAcres: number | undefined;
    cropQuantities: FarmerCropQuantity[] | undefined;
    nutrientSourceQuantities: FarmerNutrientSourceQuantity[] | undefined;
    nutrientRecommendationQuantities: FarmerNutrientRecommendationQuantity[] | undefined;
    nmpComplete: boolean | undefined;
    nmpTypeId: number | undefined;
    nmpType: NMPType;
    nmpHasBeenStarted: boolean | undefined;
    nmpCompletionDate: moment.Moment | undefined;
    nmpAcreageQuantity: number | undefined;
    factComplete: boolean | undefined;
    factCompletionDate: moment.Moment | undefined;
    nutrientApplication: number | undefined;
    sensitiveAreas: boolean | undefined;
    manureStorages: FarmerManureStorage[] | undefined;
    costShares: FarmerCostShare[] | undefined;
    watersheds: FarmerWatershed[] | undefined;
    cCertifications: CCertification[] | undefined;
    profileMissingFields: string | undefined;
    profileErrors: string | undefined;
    lastModifierUser: User;
    infoRepresentsEntireFarmingOperation: boolean | undefined;
    infoSubjectToAuditByIndependentAuditors: boolean | undefined;
    infoFairAndAccurateToBestAbility: boolean | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CostShare implements ICostShare {
    name: string | undefined;
    id: number;

    constructor(data?: ICostShare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CostShare {
        data = typeof data === 'object' ? data : {};
        let result = new CostShare();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): CostShare {
        const json = this.toJSON();
        let result = new CostShare();
        result.init(json);
        return result;
    }
}

export interface ICostShare {
    name: string | undefined;
    id: number;
}

export class FarmerCostShare implements IFarmerCostShare {
    farmerId: number;
    farmer: Farmer;
    costShareId: number;
    costShare: CostShare;
    id: number;

    constructor(data?: IFarmerCostShare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.farmer = _data["farmer"] ? Farmer.fromJS(_data["farmer"]) : <any>undefined;
            this.costShareId = _data["costShareId"];
            this.costShare = _data["costShare"] ? CostShare.fromJS(_data["costShare"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerCostShare {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerCostShare();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["farmer"] = this.farmer ? this.farmer.toJSON() : <any>undefined;
        data["costShareId"] = this.costShareId;
        data["costShare"] = this.costShare ? this.costShare.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerCostShare {
        const json = this.toJSON();
        let result = new FarmerCostShare();
        result.init(json);
        return result;
    }
}

export interface IFarmerCostShare {
    farmerId: number;
    farmer: Farmer;
    costShareId: number;
    costShare: CostShare;
    id: number;
}

export class FarmerCountyDto implements IFarmerCountyDto {
    farmerId: number;
    countyId: number;
    countyName: string | undefined;
    id: number;

    constructor(data?: IFarmerCountyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.countyId = _data["countyId"];
            this.countyName = _data["countyName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerCountyDto {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerCountyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["countyId"] = this.countyId;
        data["countyName"] = this.countyName;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerCountyDto {
        const json = this.toJSON();
        let result = new FarmerCountyDto();
        result.init(json);
        return result;
    }
}

export interface IFarmerCountyDto {
    farmerId: number;
    countyId: number;
    countyName: string | undefined;
    id: number;
}

export class FarmerCropQuantityDto implements IFarmerCropQuantityDto {
    farmerId: number;
    cropId: number;
    cropName: string | undefined;
    cropIsDefault: boolean;
    quantity: number | undefined;
    id: number;

    constructor(data?: IFarmerCropQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.cropId = _data["cropId"];
            this.cropName = _data["cropName"];
            this.cropIsDefault = _data["cropIsDefault"];
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerCropQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerCropQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["cropId"] = this.cropId;
        data["cropName"] = this.cropName;
        data["cropIsDefault"] = this.cropIsDefault;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerCropQuantityDto {
        const json = this.toJSON();
        let result = new FarmerCropQuantityDto();
        result.init(json);
        return result;
    }
}

export interface IFarmerCropQuantityDto {
    farmerId: number;
    cropId: number;
    cropName: string | undefined;
    cropIsDefault: boolean;
    quantity: number | undefined;
    id: number;
}

export class FarmerManureStorageDto implements IFarmerManureStorageDto {
    farmerId: number;
    manureStorageSourceId: number;
    manureStorageSourceName: string | undefined;
    manureStorageDurationId: number;
    manureStorageDurationName: string | undefined;
    manureStorageTypeId: number;
    manureStorageTypeName: string | undefined;
    id: number;

    constructor(data?: IFarmerManureStorageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.manureStorageSourceId = _data["manureStorageSourceId"];
            this.manureStorageSourceName = _data["manureStorageSourceName"];
            this.manureStorageDurationId = _data["manureStorageDurationId"];
            this.manureStorageDurationName = _data["manureStorageDurationName"];
            this.manureStorageTypeId = _data["manureStorageTypeId"];
            this.manureStorageTypeName = _data["manureStorageTypeName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerManureStorageDto {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerManureStorageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["manureStorageSourceId"] = this.manureStorageSourceId;
        data["manureStorageSourceName"] = this.manureStorageSourceName;
        data["manureStorageDurationId"] = this.manureStorageDurationId;
        data["manureStorageDurationName"] = this.manureStorageDurationName;
        data["manureStorageTypeId"] = this.manureStorageTypeId;
        data["manureStorageTypeName"] = this.manureStorageTypeName;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerManureStorageDto {
        const json = this.toJSON();
        let result = new FarmerManureStorageDto();
        result.init(json);
        return result;
    }
}

export interface IFarmerManureStorageDto {
    farmerId: number;
    manureStorageSourceId: number;
    manureStorageSourceName: string | undefined;
    manureStorageDurationId: number;
    manureStorageDurationName: string | undefined;
    manureStorageTypeId: number;
    manureStorageTypeName: string | undefined;
    id: number;
}

export class FarmerNutrientRecommendationQuantityDto implements IFarmerNutrientRecommendationQuantityDto {
    farmerId: number;
    nutrientRecommendationId: number;
    nutrientRecommendationName: string | undefined;
    nutrientRecommendationIsFullService: boolean;
    ownedQuantity: number | undefined;
    rentedQuantity: number | undefined;
    id: number;

    constructor(data?: IFarmerNutrientRecommendationQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.nutrientRecommendationId = _data["nutrientRecommendationId"];
            this.nutrientRecommendationName = _data["nutrientRecommendationName"];
            this.nutrientRecommendationIsFullService = _data["nutrientRecommendationIsFullService"];
            this.ownedQuantity = _data["ownedQuantity"];
            this.rentedQuantity = _data["rentedQuantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerNutrientRecommendationQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerNutrientRecommendationQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["nutrientRecommendationId"] = this.nutrientRecommendationId;
        data["nutrientRecommendationName"] = this.nutrientRecommendationName;
        data["nutrientRecommendationIsFullService"] = this.nutrientRecommendationIsFullService;
        data["ownedQuantity"] = this.ownedQuantity;
        data["rentedQuantity"] = this.rentedQuantity;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerNutrientRecommendationQuantityDto {
        const json = this.toJSON();
        let result = new FarmerNutrientRecommendationQuantityDto();
        result.init(json);
        return result;
    }
}

export interface IFarmerNutrientRecommendationQuantityDto {
    farmerId: number;
    nutrientRecommendationId: number;
    nutrientRecommendationName: string | undefined;
    nutrientRecommendationIsFullService: boolean;
    ownedQuantity: number | undefined;
    rentedQuantity: number | undefined;
    id: number;
}

export class FarmerNutrientSourceQuantityDto implements IFarmerNutrientSourceQuantityDto {
    farmerId: number;
    nutrientSourceId: number;
    nutrientSourceName: string | undefined;
    nutrientSourceSort: number;
    ownedQuantity: number | undefined;
    rentedQuantity: number | undefined;
    id: number;

    constructor(data?: IFarmerNutrientSourceQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.nutrientSourceId = _data["nutrientSourceId"];
            this.nutrientSourceName = _data["nutrientSourceName"];
            this.nutrientSourceSort = _data["nutrientSourceSort"];
            this.ownedQuantity = _data["ownedQuantity"];
            this.rentedQuantity = _data["rentedQuantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerNutrientSourceQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerNutrientSourceQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["nutrientSourceId"] = this.nutrientSourceId;
        data["nutrientSourceName"] = this.nutrientSourceName;
        data["nutrientSourceSort"] = this.nutrientSourceSort;
        data["ownedQuantity"] = this.ownedQuantity;
        data["rentedQuantity"] = this.rentedQuantity;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerNutrientSourceQuantityDto {
        const json = this.toJSON();
        let result = new FarmerNutrientSourceQuantityDto();
        result.init(json);
        return result;
    }
}

export interface IFarmerNutrientSourceQuantityDto {
    farmerId: number;
    nutrientSourceId: number;
    nutrientSourceName: string | undefined;
    nutrientSourceSort: number;
    ownedQuantity: number | undefined;
    rentedQuantity: number | undefined;
    id: number;
}

export class FarmerDto implements IFarmerDto {
    userId: number;
    userFirstName: string | undefined;
    userLastName: string | undefined;
    userEmailAddress: string | undefined;
    userPhoneNumber: string | undefined;
    userName: string | undefined;
    userUserName: string | undefined;
    farmName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    ownedAcres: number | undefined;
    rentedAcres: number | undefined;
    nmpComplete: boolean | undefined;
    nmpTypeId: number | undefined;
    nmpHasBeenStarted: boolean | undefined;
    nmpCompletionDate: moment.Moment | undefined;
    nmpAcreageQuantity: number | undefined;
    factComplete: boolean | undefined;
    factCompletionDate: moment.Moment | undefined;
    nutrientApplication: number | undefined;
    sensitiveAreas: boolean | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    countyNames: string | undefined;
    watershedNames: string | undefined;
    hasPassedCertification: number | undefined;
    profileMissingFields: string | undefined;
    hasProfileMissingFields: boolean;
    profileErrors: string | undefined;
    hasProfileErrors: boolean;
    infoRepresentsEntireFarmingOperation: boolean | undefined;
    infoSubjectToAuditByIndependentAuditors: boolean | undefined;
    infoFairAndAccurateToBestAbility: boolean | undefined;
    id: number;

    constructor(data?: IFarmerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userFirstName = _data["userFirstName"];
            this.userLastName = _data["userLastName"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.userPhoneNumber = _data["userPhoneNumber"];
            this.userName = _data["userName"];
            this.userUserName = _data["userUserName"];
            this.farmName = _data["farmName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.ownedAcres = _data["ownedAcres"];
            this.rentedAcres = _data["rentedAcres"];
            this.nmpComplete = _data["nmpComplete"];
            this.nmpTypeId = _data["nmpTypeId"];
            this.nmpHasBeenStarted = _data["nmpHasBeenStarted"];
            this.nmpCompletionDate = _data["nmpCompletionDate"] ? moment(_data["nmpCompletionDate"].toString()) : <any>undefined;
            this.nmpAcreageQuantity = _data["nmpAcreageQuantity"];
            this.factComplete = _data["factComplete"];
            this.factCompletionDate = _data["factCompletionDate"] ? moment(_data["factCompletionDate"].toString()) : <any>undefined;
            this.nutrientApplication = _data["nutrientApplication"];
            this.sensitiveAreas = _data["sensitiveAreas"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserName = _data["lastModifierUserName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.countyNames = _data["countyNames"];
            this.watershedNames = _data["watershedNames"];
            this.hasPassedCertification = _data["hasPassedCertification"];
            this.profileMissingFields = _data["profileMissingFields"];
            this.hasProfileMissingFields = _data["hasProfileMissingFields"];
            this.profileErrors = _data["profileErrors"];
            this.hasProfileErrors = _data["hasProfileErrors"];
            this.infoRepresentsEntireFarmingOperation = _data["infoRepresentsEntireFarmingOperation"];
            this.infoSubjectToAuditByIndependentAuditors = _data["infoSubjectToAuditByIndependentAuditors"];
            this.infoFairAndAccurateToBestAbility = _data["infoFairAndAccurateToBestAbility"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerDto {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userFirstName"] = this.userFirstName;
        data["userLastName"] = this.userLastName;
        data["userEmailAddress"] = this.userEmailAddress;
        data["userPhoneNumber"] = this.userPhoneNumber;
        data["userName"] = this.userName;
        data["userUserName"] = this.userUserName;
        data["farmName"] = this.farmName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["ownedAcres"] = this.ownedAcres;
        data["rentedAcres"] = this.rentedAcres;
        data["nmpComplete"] = this.nmpComplete;
        data["nmpTypeId"] = this.nmpTypeId;
        data["nmpHasBeenStarted"] = this.nmpHasBeenStarted;
        data["nmpCompletionDate"] = this.nmpCompletionDate ? this.nmpCompletionDate.toISOString() : <any>undefined;
        data["nmpAcreageQuantity"] = this.nmpAcreageQuantity;
        data["factComplete"] = this.factComplete;
        data["factCompletionDate"] = this.factCompletionDate ? this.factCompletionDate.toISOString() : <any>undefined;
        data["nutrientApplication"] = this.nutrientApplication;
        data["sensitiveAreas"] = this.sensitiveAreas;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["countyNames"] = this.countyNames;
        data["watershedNames"] = this.watershedNames;
        data["hasPassedCertification"] = this.hasPassedCertification;
        data["profileMissingFields"] = this.profileMissingFields;
        data["hasProfileMissingFields"] = this.hasProfileMissingFields;
        data["profileErrors"] = this.profileErrors;
        data["hasProfileErrors"] = this.hasProfileErrors;
        data["infoRepresentsEntireFarmingOperation"] = this.infoRepresentsEntireFarmingOperation;
        data["infoSubjectToAuditByIndependentAuditors"] = this.infoSubjectToAuditByIndependentAuditors;
        data["infoFairAndAccurateToBestAbility"] = this.infoFairAndAccurateToBestAbility;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerDto {
        const json = this.toJSON();
        let result = new FarmerDto();
        result.init(json);
        return result;
    }
}

export interface IFarmerDto {
    userId: number;
    userFirstName: string | undefined;
    userLastName: string | undefined;
    userEmailAddress: string | undefined;
    userPhoneNumber: string | undefined;
    userName: string | undefined;
    userUserName: string | undefined;
    farmName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    ownedAcres: number | undefined;
    rentedAcres: number | undefined;
    nmpComplete: boolean | undefined;
    nmpTypeId: number | undefined;
    nmpHasBeenStarted: boolean | undefined;
    nmpCompletionDate: moment.Moment | undefined;
    nmpAcreageQuantity: number | undefined;
    factComplete: boolean | undefined;
    factCompletionDate: moment.Moment | undefined;
    nutrientApplication: number | undefined;
    sensitiveAreas: boolean | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    countyNames: string | undefined;
    watershedNames: string | undefined;
    hasPassedCertification: number | undefined;
    profileMissingFields: string | undefined;
    hasProfileMissingFields: boolean;
    profileErrors: string | undefined;
    hasProfileErrors: boolean;
    infoRepresentsEntireFarmingOperation: boolean | undefined;
    infoSubjectToAuditByIndependentAuditors: boolean | undefined;
    infoFairAndAccurateToBestAbility: boolean | undefined;
    id: number;
}

export class FarmerDtoPagedResultDto implements IFarmerDtoPagedResultDto {
    totalCount: number;
    items: FarmerDto[] | undefined;

    constructor(data?: IFarmerDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FarmerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FarmerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FarmerDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FarmerDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFarmerDtoPagedResultDto {
    totalCount: number;
    items: FarmerDto[] | undefined;
}

export class FarmerUpdateDto implements IFarmerUpdateDto {
    id: number;
    userId: number;
    farmName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    ownedAcres: number | undefined;
    rentedAcres: number | undefined;
    nmpComplete: boolean | undefined;
    nmpTypeId: number | undefined;
    nmpHasBeenStarted: boolean | undefined;
    nmpCompletionDate: moment.Moment | undefined;
    nmpAcreageQuantity: number | undefined;
    factComplete: boolean | undefined;
    factCompletionDate: moment.Moment | undefined;
    nutrientApplication: number | undefined;
    sensitiveAreas: boolean | undefined;
    profileMissingFields: string | undefined;
    profileErrors: string | undefined;
    infoRepresentsEntireFarmingOperation: boolean | undefined;
    infoSubjectToAuditByIndependentAuditors: boolean | undefined;
    infoFairAndAccurateToBestAbility: boolean | undefined;
    token: string;

    constructor(data?: IFarmerUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.farmName = _data["farmName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.ownedAcres = _data["ownedAcres"];
            this.rentedAcres = _data["rentedAcres"];
            this.nmpComplete = _data["nmpComplete"];
            this.nmpTypeId = _data["nmpTypeId"];
            this.nmpHasBeenStarted = _data["nmpHasBeenStarted"];
            this.nmpCompletionDate = _data["nmpCompletionDate"] ? moment(_data["nmpCompletionDate"].toString()) : <any>undefined;
            this.nmpAcreageQuantity = _data["nmpAcreageQuantity"];
            this.factComplete = _data["factComplete"];
            this.factCompletionDate = _data["factCompletionDate"] ? moment(_data["factCompletionDate"].toString()) : <any>undefined;
            this.nutrientApplication = _data["nutrientApplication"];
            this.sensitiveAreas = _data["sensitiveAreas"];
            this.profileMissingFields = _data["profileMissingFields"];
            this.profileErrors = _data["profileErrors"];
            this.infoRepresentsEntireFarmingOperation = _data["infoRepresentsEntireFarmingOperation"];
            this.infoSubjectToAuditByIndependentAuditors = _data["infoSubjectToAuditByIndependentAuditors"];
            this.infoFairAndAccurateToBestAbility = _data["infoFairAndAccurateToBestAbility"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): FarmerUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["farmName"] = this.farmName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["ownedAcres"] = this.ownedAcres;
        data["rentedAcres"] = this.rentedAcres;
        data["nmpComplete"] = this.nmpComplete;
        data["nmpTypeId"] = this.nmpTypeId;
        data["nmpHasBeenStarted"] = this.nmpHasBeenStarted;
        data["nmpCompletionDate"] = this.nmpCompletionDate ? this.nmpCompletionDate.toISOString() : <any>undefined;
        data["nmpAcreageQuantity"] = this.nmpAcreageQuantity;
        data["factComplete"] = this.factComplete;
        data["factCompletionDate"] = this.factCompletionDate ? this.factCompletionDate.toISOString() : <any>undefined;
        data["nutrientApplication"] = this.nutrientApplication;
        data["sensitiveAreas"] = this.sensitiveAreas;
        data["profileMissingFields"] = this.profileMissingFields;
        data["profileErrors"] = this.profileErrors;
        data["infoRepresentsEntireFarmingOperation"] = this.infoRepresentsEntireFarmingOperation;
        data["infoSubjectToAuditByIndependentAuditors"] = this.infoSubjectToAuditByIndependentAuditors;
        data["infoFairAndAccurateToBestAbility"] = this.infoFairAndAccurateToBestAbility;
        data["token"] = this.token;
        return data; 
    }

    clone(): FarmerUpdateDto {
        const json = this.toJSON();
        let result = new FarmerUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IFarmerUpdateDto {
    id: number;
    userId: number;
    farmName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    ownedAcres: number | undefined;
    rentedAcres: number | undefined;
    nmpComplete: boolean | undefined;
    nmpTypeId: number | undefined;
    nmpHasBeenStarted: boolean | undefined;
    nmpCompletionDate: moment.Moment | undefined;
    nmpAcreageQuantity: number | undefined;
    factComplete: boolean | undefined;
    factCompletionDate: moment.Moment | undefined;
    nutrientApplication: number | undefined;
    sensitiveAreas: boolean | undefined;
    profileMissingFields: string | undefined;
    profileErrors: string | undefined;
    infoRepresentsEntireFarmingOperation: boolean | undefined;
    infoSubjectToAuditByIndependentAuditors: boolean | undefined;
    infoFairAndAccurateToBestAbility: boolean | undefined;
    token: string;
}

export class FarmerCreateDto implements IFarmerCreateDto {
    userId: number;
    farmName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    ownedAcres: number | undefined;
    rentedAcres: number | undefined;
    nmpComplete: boolean | undefined;
    nmpTypeId: number | undefined;
    nmpHasBeenStarted: boolean | undefined;
    nmpCompletionDate: moment.Moment | undefined;
    nmpAcreageQuantity: number | undefined;
    factComplete: boolean | undefined;
    factCompletionDate: moment.Moment | undefined;
    nutrientApplication: number | undefined;
    sensitiveAreas: boolean | undefined;
    profileMissingFields: string | undefined;
    profileErrors: string | undefined;
    infoRepresentsEntireFarmingOperation: boolean | undefined;
    infoSubjectToAuditByIndependentAuditors: boolean | undefined;
    infoFairAndAccurateToBestAbility: boolean | undefined;
    token: string;

    constructor(data?: IFarmerCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.farmName = _data["farmName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.ownedAcres = _data["ownedAcres"];
            this.rentedAcres = _data["rentedAcres"];
            this.nmpComplete = _data["nmpComplete"];
            this.nmpTypeId = _data["nmpTypeId"];
            this.nmpHasBeenStarted = _data["nmpHasBeenStarted"];
            this.nmpCompletionDate = _data["nmpCompletionDate"] ? moment(_data["nmpCompletionDate"].toString()) : <any>undefined;
            this.nmpAcreageQuantity = _data["nmpAcreageQuantity"];
            this.factComplete = _data["factComplete"];
            this.factCompletionDate = _data["factCompletionDate"] ? moment(_data["factCompletionDate"].toString()) : <any>undefined;
            this.nutrientApplication = _data["nutrientApplication"];
            this.sensitiveAreas = _data["sensitiveAreas"];
            this.profileMissingFields = _data["profileMissingFields"];
            this.profileErrors = _data["profileErrors"];
            this.infoRepresentsEntireFarmingOperation = _data["infoRepresentsEntireFarmingOperation"];
            this.infoSubjectToAuditByIndependentAuditors = _data["infoSubjectToAuditByIndependentAuditors"];
            this.infoFairAndAccurateToBestAbility = _data["infoFairAndAccurateToBestAbility"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): FarmerCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["farmName"] = this.farmName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["ownedAcres"] = this.ownedAcres;
        data["rentedAcres"] = this.rentedAcres;
        data["nmpComplete"] = this.nmpComplete;
        data["nmpTypeId"] = this.nmpTypeId;
        data["nmpHasBeenStarted"] = this.nmpHasBeenStarted;
        data["nmpCompletionDate"] = this.nmpCompletionDate ? this.nmpCompletionDate.toISOString() : <any>undefined;
        data["nmpAcreageQuantity"] = this.nmpAcreageQuantity;
        data["factComplete"] = this.factComplete;
        data["factCompletionDate"] = this.factCompletionDate ? this.factCompletionDate.toISOString() : <any>undefined;
        data["nutrientApplication"] = this.nutrientApplication;
        data["sensitiveAreas"] = this.sensitiveAreas;
        data["profileMissingFields"] = this.profileMissingFields;
        data["profileErrors"] = this.profileErrors;
        data["infoRepresentsEntireFarmingOperation"] = this.infoRepresentsEntireFarmingOperation;
        data["infoSubjectToAuditByIndependentAuditors"] = this.infoSubjectToAuditByIndependentAuditors;
        data["infoFairAndAccurateToBestAbility"] = this.infoFairAndAccurateToBestAbility;
        data["token"] = this.token;
        return data; 
    }

    clone(): FarmerCreateDto {
        const json = this.toJSON();
        let result = new FarmerCreateDto();
        result.init(json);
        return result;
    }
}

export interface IFarmerCreateDto {
    userId: number;
    farmName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    ownedAcres: number | undefined;
    rentedAcres: number | undefined;
    nmpComplete: boolean | undefined;
    nmpTypeId: number | undefined;
    nmpHasBeenStarted: boolean | undefined;
    nmpCompletionDate: moment.Moment | undefined;
    nmpAcreageQuantity: number | undefined;
    factComplete: boolean | undefined;
    factCompletionDate: moment.Moment | undefined;
    nutrientApplication: number | undefined;
    sensitiveAreas: boolean | undefined;
    profileMissingFields: string | undefined;
    profileErrors: string | undefined;
    infoRepresentsEntireFarmingOperation: boolean | undefined;
    infoSubjectToAuditByIndependentAuditors: boolean | undefined;
    infoFairAndAccurateToBestAbility: boolean | undefined;
    token: string;
}

export class UserDto implements IUserDto {
    userName: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    isActive: boolean;
    fullName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    id: number;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    userName: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    isActive: boolean;
    fullName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    id: number;
}

export class FarmerSaveDto implements IFarmerSaveDto {
    farmerDto: FarmerDto;
    userDto: UserDto;

    constructor(data?: IFarmerSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerDto = _data["farmerDto"] ? FarmerDto.fromJS(_data["farmerDto"]) : <any>undefined;
            this.userDto = _data["userDto"] ? UserDto.fromJS(_data["userDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FarmerSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerDto"] = this.farmerDto ? this.farmerDto.toJSON() : <any>undefined;
        data["userDto"] = this.userDto ? this.userDto.toJSON() : <any>undefined;
        return data; 
    }

    clone(): FarmerSaveDto {
        const json = this.toJSON();
        let result = new FarmerSaveDto();
        result.init(json);
        return result;
    }
}

export interface IFarmerSaveDto {
    farmerDto: FarmerDto;
    userDto: UserDto;
}

export class FarmerWatershedDto implements IFarmerWatershedDto {
    farmerId: number;
    watershedId: number;
    watershedName: string | undefined;
    watershedCode: string | undefined;
    id: number;

    constructor(data?: IFarmerWatershedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmerId = _data["farmerId"];
            this.watershedId = _data["watershedId"];
            this.watershedName = _data["watershedName"];
            this.watershedCode = _data["watershedCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FarmerWatershedDto {
        data = typeof data === 'object' ? data : {};
        let result = new FarmerWatershedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmerId"] = this.farmerId;
        data["watershedId"] = this.watershedId;
        data["watershedName"] = this.watershedName;
        data["watershedCode"] = this.watershedCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): FarmerWatershedDto {
        const json = this.toJSON();
        let result = new FarmerWatershedDto();
        result.init(json);
        return result;
    }
}

export interface IFarmerWatershedDto {
    farmerId: number;
    watershedId: number;
    watershedName: string | undefined;
    watershedCode: string | undefined;
    id: number;
}

export class ManureStorageDurationDto implements IManureStorageDurationDto {
    name: string | undefined;
    id: number;

    constructor(data?: IManureStorageDurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ManureStorageDurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManureStorageDurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): ManureStorageDurationDto {
        const json = this.toJSON();
        let result = new ManureStorageDurationDto();
        result.init(json);
        return result;
    }
}

export interface IManureStorageDurationDto {
    name: string | undefined;
    id: number;
}

export class ManureStorageSourceDto implements IManureStorageSourceDto {
    name: string | undefined;
    id: number;

    constructor(data?: IManureStorageSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ManureStorageSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManureStorageSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): ManureStorageSourceDto {
        const json = this.toJSON();
        let result = new ManureStorageSourceDto();
        result.init(json);
        return result;
    }
}

export interface IManureStorageSourceDto {
    name: string | undefined;
    id: number;
}

export class ManureStorageTypeDto implements IManureStorageTypeDto {
    name: string | undefined;
    id: number;

    constructor(data?: IManureStorageTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ManureStorageTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManureStorageTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): ManureStorageTypeDto {
        const json = this.toJSON();
        let result = new ManureStorageTypeDto();
        result.init(json);
        return result;
    }
}

export interface IManureStorageTypeDto {
    name: string | undefined;
    id: number;
}

export class NMPTypeDto implements INMPTypeDto {
    name: string | undefined;
    isFullService: boolean;
    id: number;

    constructor(data?: INMPTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isFullService = _data["isFullService"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NMPTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NMPTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isFullService"] = this.isFullService;
        data["id"] = this.id;
        return data; 
    }

    clone(): NMPTypeDto {
        const json = this.toJSON();
        let result = new NMPTypeDto();
        result.init(json);
        return result;
    }
}

export interface INMPTypeDto {
    name: string | undefined;
    isFullService: boolean;
    id: number;
}

export class NutrientRecommendationDto implements INutrientRecommendationDto {
    name: string | undefined;
    isFullService: boolean;
    id: number;

    constructor(data?: INutrientRecommendationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isFullService = _data["isFullService"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NutrientRecommendationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientRecommendationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isFullService"] = this.isFullService;
        data["id"] = this.id;
        return data; 
    }

    clone(): NutrientRecommendationDto {
        const json = this.toJSON();
        let result = new NutrientRecommendationDto();
        result.init(json);
        return result;
    }
}

export interface INutrientRecommendationDto {
    name: string | undefined;
    isFullService: boolean;
    id: number;
}

export class NutrientSourceDto implements INutrientSourceDto {
    name: string | undefined;
    sort: number;
    id: number;

    constructor(data?: INutrientSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sort = _data["sort"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NutrientSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sort"] = this.sort;
        data["id"] = this.id;
        return data; 
    }

    clone(): NutrientSourceDto {
        const json = this.toJSON();
        let result = new NutrientSourceDto();
        result.init(json);
        return result;
    }
}

export interface INutrientSourceDto {
    name: string | undefined;
    sort: number;
    id: number;
}

export class PasswordResetTokenDto implements IPasswordResetTokenDto {
    token: string;
    userId: number;
    userEmailAddress: string | undefined;
    userUserName: string | undefined;
    expirationDate: moment.Moment;
    isActive: boolean;
    id: number;

    constructor(data?: IPasswordResetTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.userId = _data["userId"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.userUserName = _data["userUserName"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PasswordResetTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["userId"] = this.userId;
        data["userEmailAddress"] = this.userEmailAddress;
        data["userUserName"] = this.userUserName;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }

    clone(): PasswordResetTokenDto {
        const json = this.toJSON();
        let result = new PasswordResetTokenDto();
        result.init(json);
        return result;
    }
}

export interface IPasswordResetTokenDto {
    token: string;
    userId: number;
    userEmailAddress: string | undefined;
    userUserName: string | undefined;
    expirationDate: moment.Moment;
    isActive: boolean;
    id: number;
}

export class PasswordResetRequestDto implements IPasswordResetRequestDto {
    token: string | undefined;
    password: string | undefined;

    constructor(data?: IPasswordResetRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): PasswordResetRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["password"] = this.password;
        return data; 
    }

    clone(): PasswordResetRequestDto {
        const json = this.toJSON();
        let result = new PasswordResetRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPasswordResetRequestDto {
    token: string | undefined;
    password: string | undefined;
}

export class RegistrationTokenDto implements IRegistrationTokenDto {
    token: string;
    emailAddress: string | undefined;
    expirationDate: moment.Moment;
    isActive: boolean;
    id: number;

    constructor(data?: IRegistrationTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.emailAddress = _data["emailAddress"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RegistrationTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["emailAddress"] = this.emailAddress;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }

    clone(): RegistrationTokenDto {
        const json = this.toJSON();
        let result = new RegistrationTokenDto();
        result.init(json);
        return result;
    }
}

export interface IRegistrationTokenDto {
    token: string;
    emailAddress: string | undefined;
    expirationDate: moment.Moment;
    isActive: boolean;
    id: number;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string | undefined;
    displayName: string | undefined;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data; 
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string | undefined;
    displayName: string | undefined;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDto implements IRoleDto {
    name: string | undefined;
    displayName: string | undefined;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    name: string | undefined;
    displayName: string | undefined;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number;
}

export class RoleListDto implements IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isStatic: boolean;
    id: number;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isStatic: boolean;
    id: number;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data; 
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;
}

export class SecurityQuestionDto implements ISecurityQuestionDto {
    label: string | undefined;
    id: number;

    constructor(data?: ISecurityQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SecurityQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["id"] = this.id;
        return data; 
    }

    clone(): SecurityQuestionDto {
        const json = this.toJSON();
        let result = new SecurityQuestionDto();
        result.init(json);
        return result;
    }
}

export interface ISecurityQuestionDto {
    label: string | undefined;
    id: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        this.features[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data; 
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    id: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    farmer: FarmerDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            this.farmer = _data["farmer"] ? FarmerDto.fromJS(_data["farmer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["farmer"] = this.farmer ? this.farmer.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    farmer: FarmerDto;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string | undefined;
    name: string | undefined;
    adminEmailAddress: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data; 
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string | undefined;
    name: string | undefined;
    adminEmailAddress: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
}

export class TenantDto implements ITenantDto {
    tenancyName: string | undefined;
    name: string | undefined;
    isActive: boolean;
    id: number;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    tenancyName: string | undefined;
    name: string | undefined;
    isActive: boolean;
    id: number;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    totalCount: number;
    items: TenantDto[] | undefined;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    totalCount: number;
    items: TenantDto[] | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userName: string | undefined;
    password: string | undefined;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data; 
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userName: string | undefined;
    password: string | undefined;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data; 
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string | undefined;
    providerKey: string | undefined;
    providerAccessCode: string | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data; 
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string | undefined;
    providerKey: string | undefined;
    providerAccessCode: string | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data; 
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string | undefined;
    name: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string | undefined;
    phoneNumber: string | undefined;
    fullName: string | undefined;
    sendPasswordResetLink: boolean;
    sendConfirmationEmail: boolean;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
            this.phoneNumber = _data["phoneNumber"];
            this.fullName = _data["fullName"];
            this.sendPasswordResetLink = _data["sendPasswordResetLink"];
            this.sendConfirmationEmail = _data["sendConfirmationEmail"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        data["phoneNumber"] = this.phoneNumber;
        data["fullName"] = this.fullName;
        data["sendPasswordResetLink"] = this.sendPasswordResetLink;
        data["sendConfirmationEmail"] = this.sendConfirmationEmail;
        return data; 
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string | undefined;
    name: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string | undefined;
    phoneNumber: string | undefined;
    fullName: string | undefined;
    sendPasswordResetLink: boolean;
    sendConfirmationEmail: boolean;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string | undefined;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data; 
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string | undefined;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string | undefined;
    newPassword: string | undefined;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string | undefined;
    newPassword: string | undefined;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string | undefined;
    userId: number;
    newPassword: string | undefined;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data; 
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string | undefined;
    userId: number;
    newPassword: string | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;
}

export class SecurityQuestion implements ISecurityQuestion {
    label: string | undefined;
    isDeleted: boolean;
    id: number;

    constructor(data?: ISecurityQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SecurityQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data; 
    }

    clone(): SecurityQuestion {
        const json = this.toJSON();
        let result = new SecurityQuestion();
        result.init(json);
        return result;
    }
}

export interface ISecurityQuestion {
    label: string | undefined;
    isDeleted: boolean;
    id: number;
}

export class UserSecurityQuestionAnswer implements IUserSecurityQuestionAnswer {
    answer: string | undefined;
    userId: number;
    user: User;
    securityQuestionId: number;
    securityQuestion: SecurityQuestion;
    id: number;

    constructor(data?: IUserSecurityQuestionAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.securityQuestionId = _data["securityQuestionId"];
            this.securityQuestion = _data["securityQuestion"] ? SecurityQuestion.fromJS(_data["securityQuestion"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserSecurityQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new UserSecurityQuestionAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["securityQuestionId"] = this.securityQuestionId;
        data["securityQuestion"] = this.securityQuestion ? this.securityQuestion.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserSecurityQuestionAnswer {
        const json = this.toJSON();
        let result = new UserSecurityQuestionAnswer();
        result.init(json);
        return result;
    }
}

export interface IUserSecurityQuestionAnswer {
    answer: string | undefined;
    userId: number;
    user: User;
    securityQuestionId: number;
    securityQuestion: SecurityQuestion;
    id: number;
}

export class VVerificationQuestionAnswerDto implements IVVerificationQuestionAnswerDto {
    vVerificationId: number;
    vQuestionId: number;
    vQuestionDescription: string | undefined;
    vQuestionSort: number;
    vQuestionTypeId: number;
    vAnswerId: number | undefined;
    vAnswerDescription: string | undefined;
    vAnswerRequiresFreeText: boolean | undefined;
    alternateAnswer: string | undefined;
    id: number;

    constructor(data?: IVVerificationQuestionAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vVerificationId = _data["vVerificationId"];
            this.vQuestionId = _data["vQuestionId"];
            this.vQuestionDescription = _data["vQuestionDescription"];
            this.vQuestionSort = _data["vQuestionSort"];
            this.vQuestionTypeId = _data["vQuestionTypeId"];
            this.vAnswerId = _data["vAnswerId"];
            this.vAnswerDescription = _data["vAnswerDescription"];
            this.vAnswerRequiresFreeText = _data["vAnswerRequiresFreeText"];
            this.alternateAnswer = _data["alternateAnswer"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VVerificationQuestionAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationQuestionAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vVerificationId"] = this.vVerificationId;
        data["vQuestionId"] = this.vQuestionId;
        data["vQuestionDescription"] = this.vQuestionDescription;
        data["vQuestionSort"] = this.vQuestionSort;
        data["vQuestionTypeId"] = this.vQuestionTypeId;
        data["vAnswerId"] = this.vAnswerId;
        data["vAnswerDescription"] = this.vAnswerDescription;
        data["vAnswerRequiresFreeText"] = this.vAnswerRequiresFreeText;
        data["alternateAnswer"] = this.alternateAnswer;
        data["id"] = this.id;
        return data; 
    }

    clone(): VVerificationQuestionAnswerDto {
        const json = this.toJSON();
        let result = new VVerificationQuestionAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationQuestionAnswerDto {
    vVerificationId: number;
    vQuestionId: number;
    vQuestionDescription: string | undefined;
    vQuestionSort: number;
    vQuestionTypeId: number;
    vAnswerId: number | undefined;
    vAnswerDescription: string | undefined;
    vAnswerRequiresFreeText: boolean | undefined;
    alternateAnswer: string | undefined;
    id: number;
}

export class VQuestionDto implements IVQuestionDto {
    description: string | undefined;
    sort: number;
    typeId: number;
    isActive: boolean;
    questionNumber: number;
    vQuestionGroupId: number | undefined;
    id: number;

    constructor(data?: IVQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.sort = _data["sort"];
            this.typeId = _data["typeId"];
            this.isActive = _data["isActive"];
            this.questionNumber = _data["questionNumber"];
            this.vQuestionGroupId = _data["vQuestionGroupId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new VQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["sort"] = this.sort;
        data["typeId"] = this.typeId;
        data["isActive"] = this.isActive;
        data["questionNumber"] = this.questionNumber;
        data["vQuestionGroupId"] = this.vQuestionGroupId;
        data["id"] = this.id;
        return data; 
    }

    clone(): VQuestionDto {
        const json = this.toJSON();
        let result = new VQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IVQuestionDto {
    description: string | undefined;
    sort: number;
    typeId: number;
    isActive: boolean;
    questionNumber: number;
    vQuestionGroupId: number | undefined;
    id: number;
}

export class VAnswerDto implements IVAnswerDto {
    description: string | undefined;
    reportDescription: string | undefined;
    requiresFreeText: boolean;
    isActive: boolean;
    id: number;

    constructor(data?: IVAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.reportDescription = _data["reportDescription"];
            this.requiresFreeText = _data["requiresFreeText"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new VAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["reportDescription"] = this.reportDescription;
        data["requiresFreeText"] = this.requiresFreeText;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }

    clone(): VAnswerDto {
        const json = this.toJSON();
        let result = new VAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IVAnswerDto {
    description: string | undefined;
    reportDescription: string | undefined;
    requiresFreeText: boolean;
    isActive: boolean;
    id: number;
}

export class VVerificationQuestionNoteDto implements IVVerificationQuestionNoteDto {
    vVerificationId: number;
    vQuestionId: number;
    comments: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifiedUserId: number | undefined;
    lastModifiedUserName: string | undefined;
    lastModifiedTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;

    constructor(data?: IVVerificationQuestionNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vVerificationId = _data["vVerificationId"];
            this.vQuestionId = _data["vQuestionId"];
            this.comments = _data["comments"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserName = _data["lastModifierUserName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifiedUserId = _data["lastModifiedUserId"];
            this.lastModifiedUserName = _data["lastModifiedUserName"];
            this.lastModifiedTime = _data["lastModifiedTime"] ? moment(_data["lastModifiedTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VVerificationQuestionNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationQuestionNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vVerificationId"] = this.vVerificationId;
        data["vQuestionId"] = this.vQuestionId;
        data["comments"] = this.comments;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifiedUserId"] = this.lastModifiedUserId;
        data["lastModifiedUserName"] = this.lastModifiedUserName;
        data["lastModifiedTime"] = this.lastModifiedTime ? this.lastModifiedTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data; 
    }

    clone(): VVerificationQuestionNoteDto {
        const json = this.toJSON();
        let result = new VVerificationQuestionNoteDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationQuestionNoteDto {
    vVerificationId: number;
    vQuestionId: number;
    comments: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifiedUserId: number | undefined;
    lastModifiedUserName: string | undefined;
    lastModifiedTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;
}

export class VVerificationQuestionWithAnswersDto implements IVVerificationQuestionWithAnswersDto {
    vVQASingleDto: VVerificationQuestionAnswerDto;
    vVQAMultipleDto: VVerificationQuestionAnswerDto[] | undefined;
    vQuestionDto: VQuestionDto;
    vAnswerDtos: VAnswerDto[] | undefined;
    vVerificationQuestionNoteDto: VVerificationQuestionNoteDto;

    constructor(data?: IVVerificationQuestionWithAnswersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vVQASingleDto = _data["vVQASingleDto"] ? VVerificationQuestionAnswerDto.fromJS(_data["vVQASingleDto"]) : <any>undefined;
            if (Array.isArray(_data["vVQAMultipleDto"])) {
                this.vVQAMultipleDto = [] as any;
                for (let item of _data["vVQAMultipleDto"])
                    this.vVQAMultipleDto.push(VVerificationQuestionAnswerDto.fromJS(item));
            }
            this.vQuestionDto = _data["vQuestionDto"] ? VQuestionDto.fromJS(_data["vQuestionDto"]) : <any>undefined;
            if (Array.isArray(_data["vAnswerDtos"])) {
                this.vAnswerDtos = [] as any;
                for (let item of _data["vAnswerDtos"])
                    this.vAnswerDtos.push(VAnswerDto.fromJS(item));
            }
            this.vVerificationQuestionNoteDto = _data["vVerificationQuestionNoteDto"] ? VVerificationQuestionNoteDto.fromJS(_data["vVerificationQuestionNoteDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VVerificationQuestionWithAnswersDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationQuestionWithAnswersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vVQASingleDto"] = this.vVQASingleDto ? this.vVQASingleDto.toJSON() : <any>undefined;
        if (Array.isArray(this.vVQAMultipleDto)) {
            data["vVQAMultipleDto"] = [];
            for (let item of this.vVQAMultipleDto)
                data["vVQAMultipleDto"].push(item.toJSON());
        }
        data["vQuestionDto"] = this.vQuestionDto ? this.vQuestionDto.toJSON() : <any>undefined;
        if (Array.isArray(this.vAnswerDtos)) {
            data["vAnswerDtos"] = [];
            for (let item of this.vAnswerDtos)
                data["vAnswerDtos"].push(item.toJSON());
        }
        data["vVerificationQuestionNoteDto"] = this.vVerificationQuestionNoteDto ? this.vVerificationQuestionNoteDto.toJSON() : <any>undefined;
        return data; 
    }

    clone(): VVerificationQuestionWithAnswersDto {
        const json = this.toJSON();
        let result = new VVerificationQuestionWithAnswersDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationQuestionWithAnswersDto {
    vVQASingleDto: VVerificationQuestionAnswerDto;
    vVQAMultipleDto: VVerificationQuestionAnswerDto[] | undefined;
    vQuestionDto: VQuestionDto;
    vAnswerDtos: VAnswerDto[] | undefined;
    vVerificationQuestionNoteDto: VVerificationQuestionNoteDto;
}

export class VVerificationQuestionWithAnswersGroupDto implements IVVerificationQuestionWithAnswersGroupDto {
    description: string | undefined;
    sort: number;
    vVQWADtos: VVerificationQuestionWithAnswersDto[] | undefined;
    isMultiQuestionGroup: boolean;

    constructor(data?: IVVerificationQuestionWithAnswersGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.sort = _data["sort"];
            if (Array.isArray(_data["vVQWADtos"])) {
                this.vVQWADtos = [] as any;
                for (let item of _data["vVQWADtos"])
                    this.vVQWADtos.push(VVerificationQuestionWithAnswersDto.fromJS(item));
            }
            this.isMultiQuestionGroup = _data["isMultiQuestionGroup"];
        }
    }

    static fromJS(data: any): VVerificationQuestionWithAnswersGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationQuestionWithAnswersGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["sort"] = this.sort;
        if (Array.isArray(this.vVQWADtos)) {
            data["vVQWADtos"] = [];
            for (let item of this.vVQWADtos)
                data["vVQWADtos"].push(item.toJSON());
        }
        data["isMultiQuestionGroup"] = this.isMultiQuestionGroup;
        return data; 
    }

    clone(): VVerificationQuestionWithAnswersGroupDto {
        const json = this.toJSON();
        let result = new VVerificationQuestionWithAnswersGroupDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationQuestionWithAnswersGroupDto {
    description: string | undefined;
    sort: number;
    vVQWADtos: VVerificationQuestionWithAnswersDto[] | undefined;
    isMultiQuestionGroup: boolean;
}

export class VVerificationQuestionAnswerCreateDto implements IVVerificationQuestionAnswerCreateDto {
    vVerificationId: number;
    vQuestionId: number;
    vQuestionDescription: string | undefined;
    vQuestionSort: number;
    vQuestionTypeId: number;
    vAnswerId: number | undefined;
    vAnswerDescription: string | undefined;
    vAnswerRequiresFreeText: boolean | undefined;
    alternateAnswer: string | undefined;

    constructor(data?: IVVerificationQuestionAnswerCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vVerificationId = _data["vVerificationId"];
            this.vQuestionId = _data["vQuestionId"];
            this.vQuestionDescription = _data["vQuestionDescription"];
            this.vQuestionSort = _data["vQuestionSort"];
            this.vQuestionTypeId = _data["vQuestionTypeId"];
            this.vAnswerId = _data["vAnswerId"];
            this.vAnswerDescription = _data["vAnswerDescription"];
            this.vAnswerRequiresFreeText = _data["vAnswerRequiresFreeText"];
            this.alternateAnswer = _data["alternateAnswer"];
        }
    }

    static fromJS(data: any): VVerificationQuestionAnswerCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationQuestionAnswerCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vVerificationId"] = this.vVerificationId;
        data["vQuestionId"] = this.vQuestionId;
        data["vQuestionDescription"] = this.vQuestionDescription;
        data["vQuestionSort"] = this.vQuestionSort;
        data["vQuestionTypeId"] = this.vQuestionTypeId;
        data["vAnswerId"] = this.vAnswerId;
        data["vAnswerDescription"] = this.vAnswerDescription;
        data["vAnswerRequiresFreeText"] = this.vAnswerRequiresFreeText;
        data["alternateAnswer"] = this.alternateAnswer;
        return data; 
    }

    clone(): VVerificationQuestionAnswerCreateDto {
        const json = this.toJSON();
        let result = new VVerificationQuestionAnswerCreateDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationQuestionAnswerCreateDto {
    vVerificationId: number;
    vQuestionId: number;
    vQuestionDescription: string | undefined;
    vQuestionSort: number;
    vQuestionTypeId: number;
    vAnswerId: number | undefined;
    vAnswerDescription: string | undefined;
    vAnswerRequiresFreeText: boolean | undefined;
    alternateAnswer: string | undefined;
}

export class VVerificationQuestionAnswerUpdateDto implements IVVerificationQuestionAnswerUpdateDto {
    id: number;
    vVerificationId: number;
    vQuestionId: number;
    vQuestionDescription: string | undefined;
    vQuestionSort: number;
    vQuestionTypeId: number;
    vAnswerId: number | undefined;
    vAnswerDescription: string | undefined;
    vAnswerRequiresFreeText: boolean | undefined;
    alternateAnswer: string | undefined;

    constructor(data?: IVVerificationQuestionAnswerUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vVerificationId = _data["vVerificationId"];
            this.vQuestionId = _data["vQuestionId"];
            this.vQuestionDescription = _data["vQuestionDescription"];
            this.vQuestionSort = _data["vQuestionSort"];
            this.vQuestionTypeId = _data["vQuestionTypeId"];
            this.vAnswerId = _data["vAnswerId"];
            this.vAnswerDescription = _data["vAnswerDescription"];
            this.vAnswerRequiresFreeText = _data["vAnswerRequiresFreeText"];
            this.alternateAnswer = _data["alternateAnswer"];
        }
    }

    static fromJS(data: any): VVerificationQuestionAnswerUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationQuestionAnswerUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vVerificationId"] = this.vVerificationId;
        data["vQuestionId"] = this.vQuestionId;
        data["vQuestionDescription"] = this.vQuestionDescription;
        data["vQuestionSort"] = this.vQuestionSort;
        data["vQuestionTypeId"] = this.vQuestionTypeId;
        data["vAnswerId"] = this.vAnswerId;
        data["vAnswerDescription"] = this.vAnswerDescription;
        data["vAnswerRequiresFreeText"] = this.vAnswerRequiresFreeText;
        data["alternateAnswer"] = this.alternateAnswer;
        return data; 
    }

    clone(): VVerificationQuestionAnswerUpdateDto {
        const json = this.toJSON();
        let result = new VVerificationQuestionAnswerUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationQuestionAnswerUpdateDto {
    id: number;
    vVerificationId: number;
    vQuestionId: number;
    vQuestionDescription: string | undefined;
    vQuestionSort: number;
    vQuestionTypeId: number;
    vAnswerId: number | undefined;
    vAnswerDescription: string | undefined;
    vAnswerRequiresFreeText: boolean | undefined;
    alternateAnswer: string | undefined;
}

export class VVerificationQuestionAnswerDtoPagedResultDto implements IVVerificationQuestionAnswerDtoPagedResultDto {
    totalCount: number;
    items: VVerificationQuestionAnswerDto[] | undefined;

    constructor(data?: IVVerificationQuestionAnswerDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VVerificationQuestionAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VVerificationQuestionAnswerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationQuestionAnswerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): VVerificationQuestionAnswerDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VVerificationQuestionAnswerDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationQuestionAnswerDtoPagedResultDto {
    totalCount: number;
    items: VVerificationQuestionAnswerDto[] | undefined;
}

export class VVerificationQuestionNoteCreateDto implements IVVerificationQuestionNoteCreateDto {
    vVerificationId: number;
    vQuestionId: number;
    comments: string | undefined;
    lastModifiedUserId: number | undefined;
    lastModifiedUserName: string | undefined;
    lastModifiedTime: moment.Moment | undefined;

    constructor(data?: IVVerificationQuestionNoteCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vVerificationId = _data["vVerificationId"];
            this.vQuestionId = _data["vQuestionId"];
            this.comments = _data["comments"];
            this.lastModifiedUserId = _data["lastModifiedUserId"];
            this.lastModifiedUserName = _data["lastModifiedUserName"];
            this.lastModifiedTime = _data["lastModifiedTime"] ? moment(_data["lastModifiedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VVerificationQuestionNoteCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationQuestionNoteCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vVerificationId"] = this.vVerificationId;
        data["vQuestionId"] = this.vQuestionId;
        data["comments"] = this.comments;
        data["lastModifiedUserId"] = this.lastModifiedUserId;
        data["lastModifiedUserName"] = this.lastModifiedUserName;
        data["lastModifiedTime"] = this.lastModifiedTime ? this.lastModifiedTime.toISOString() : <any>undefined;
        return data; 
    }

    clone(): VVerificationQuestionNoteCreateDto {
        const json = this.toJSON();
        let result = new VVerificationQuestionNoteCreateDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationQuestionNoteCreateDto {
    vVerificationId: number;
    vQuestionId: number;
    comments: string | undefined;
    lastModifiedUserId: number | undefined;
    lastModifiedUserName: string | undefined;
    lastModifiedTime: moment.Moment | undefined;
}

export class VVerificationQuestionNoteUpdateDto implements IVVerificationQuestionNoteUpdateDto {
    id: number;
    vVerificationId: number;
    vQuestionId: number;
    comments: string | undefined;
    lastModifiedUserId: number | undefined;
    lastModifiedUserName: string | undefined;
    lastModifiedTime: moment.Moment | undefined;

    constructor(data?: IVVerificationQuestionNoteUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vVerificationId = _data["vVerificationId"];
            this.vQuestionId = _data["vQuestionId"];
            this.comments = _data["comments"];
            this.lastModifiedUserId = _data["lastModifiedUserId"];
            this.lastModifiedUserName = _data["lastModifiedUserName"];
            this.lastModifiedTime = _data["lastModifiedTime"] ? moment(_data["lastModifiedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VVerificationQuestionNoteUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationQuestionNoteUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vVerificationId"] = this.vVerificationId;
        data["vQuestionId"] = this.vQuestionId;
        data["comments"] = this.comments;
        data["lastModifiedUserId"] = this.lastModifiedUserId;
        data["lastModifiedUserName"] = this.lastModifiedUserName;
        data["lastModifiedTime"] = this.lastModifiedTime ? this.lastModifiedTime.toISOString() : <any>undefined;
        return data; 
    }

    clone(): VVerificationQuestionNoteUpdateDto {
        const json = this.toJSON();
        let result = new VVerificationQuestionNoteUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationQuestionNoteUpdateDto {
    id: number;
    vVerificationId: number;
    vQuestionId: number;
    comments: string | undefined;
    lastModifiedUserId: number | undefined;
    lastModifiedUserName: string | undefined;
    lastModifiedTime: moment.Moment | undefined;
}

export class VVerificationQuestionNoteDtoPagedResultDto implements IVVerificationQuestionNoteDtoPagedResultDto {
    totalCount: number;
    items: VVerificationQuestionNoteDto[] | undefined;

    constructor(data?: IVVerificationQuestionNoteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VVerificationQuestionNoteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VVerificationQuestionNoteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationQuestionNoteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): VVerificationQuestionNoteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VVerificationQuestionNoteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationQuestionNoteDtoPagedResultDto {
    totalCount: number;
    items: VVerificationQuestionNoteDto[] | undefined;
}

export enum VVerificationStatusEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class VVerificationDto implements IVVerificationDto {
    farmName: string | undefined;
    longitude: number | undefined;
    latitude: number | undefined;
    creatorUserName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    statusId: VVerificationStatusEnum;
    statusName: string | undefined;
    countyId: number | undefined;
    countyName: string | undefined;
    id: number;

    constructor(data?: IVVerificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmName = _data["farmName"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.creatorUserName = _data["creatorUserName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserName = _data["lastModifierUserName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.countyId = _data["countyId"];
            this.countyName = _data["countyName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VVerificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmName"] = this.farmName;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["creatorUserName"] = this.creatorUserName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["countyId"] = this.countyId;
        data["countyName"] = this.countyName;
        data["id"] = this.id;
        return data; 
    }

    clone(): VVerificationDto {
        const json = this.toJSON();
        let result = new VVerificationDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationDto {
    farmName: string | undefined;
    longitude: number | undefined;
    latitude: number | undefined;
    creatorUserName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    statusId: VVerificationStatusEnum;
    statusName: string | undefined;
    countyId: number | undefined;
    countyName: string | undefined;
    id: number;
}

export class VVerificationDtoPagedResultDto implements IVVerificationDtoPagedResultDto {
    totalCount: number;
    items: VVerificationDto[] | undefined;

    constructor(data?: IVVerificationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VVerificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VVerificationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): VVerificationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VVerificationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationDtoPagedResultDto {
    totalCount: number;
    items: VVerificationDto[] | undefined;
}

export class VVerificationWithQuestionAnswersDto implements IVVerificationWithQuestionAnswersDto {
    questionAnswers: string[] | undefined;
    farmName: string | undefined;
    longitude: number | undefined;
    latitude: number | undefined;
    creatorUserName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    statusId: VVerificationStatusEnum;
    statusName: string | undefined;
    countyId: number | undefined;
    countyName: string | undefined;
    id: number;

    constructor(data?: IVVerificationWithQuestionAnswersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["questionAnswers"])) {
                this.questionAnswers = [] as any;
                for (let item of _data["questionAnswers"])
                    this.questionAnswers.push(item);
            }
            this.farmName = _data["farmName"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.creatorUserName = _data["creatorUserName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserName = _data["lastModifierUserName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.countyId = _data["countyId"];
            this.countyName = _data["countyName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VVerificationWithQuestionAnswersDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationWithQuestionAnswersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questionAnswers)) {
            data["questionAnswers"] = [];
            for (let item of this.questionAnswers)
                data["questionAnswers"].push(item);
        }
        data["farmName"] = this.farmName;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["creatorUserName"] = this.creatorUserName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["countyId"] = this.countyId;
        data["countyName"] = this.countyName;
        data["id"] = this.id;
        return data; 
    }

    clone(): VVerificationWithQuestionAnswersDto {
        const json = this.toJSON();
        let result = new VVerificationWithQuestionAnswersDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationWithQuestionAnswersDto {
    questionAnswers: string[] | undefined;
    farmName: string | undefined;
    longitude: number | undefined;
    latitude: number | undefined;
    creatorUserName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    statusId: VVerificationStatusEnum;
    statusName: string | undefined;
    countyId: number | undefined;
    countyName: string | undefined;
    id: number;
}

export class GetAllWithQuestionAnswersDto implements IGetAllWithQuestionAnswersDto {
    vVerificationWithQuestionAnswersDtos: VVerificationWithQuestionAnswersDto[] | undefined;
    questions: string[] | undefined;

    constructor(data?: IGetAllWithQuestionAnswersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vVerificationWithQuestionAnswersDtos"])) {
                this.vVerificationWithQuestionAnswersDtos = [] as any;
                for (let item of _data["vVerificationWithQuestionAnswersDtos"])
                    this.vVerificationWithQuestionAnswersDtos.push(VVerificationWithQuestionAnswersDto.fromJS(item));
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions.push(item);
            }
        }
    }

    static fromJS(data: any): GetAllWithQuestionAnswersDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllWithQuestionAnswersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vVerificationWithQuestionAnswersDtos)) {
            data["vVerificationWithQuestionAnswersDtos"] = [];
            for (let item of this.vVerificationWithQuestionAnswersDtos)
                data["vVerificationWithQuestionAnswersDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item);
        }
        return data; 
    }

    clone(): GetAllWithQuestionAnswersDto {
        const json = this.toJSON();
        let result = new GetAllWithQuestionAnswersDto();
        result.init(json);
        return result;
    }
}

export interface IGetAllWithQuestionAnswersDto {
    vVerificationWithQuestionAnswersDtos: VVerificationWithQuestionAnswersDto[] | undefined;
    questions: string[] | undefined;
}

export class VVerificationUpdateDto implements IVVerificationUpdateDto {
    id: number;
    statusId: VVerificationStatusEnum;
    farmName: string | undefined;
    longitude: number | undefined;
    latitude: number | undefined;
    countyId: number | undefined;

    constructor(data?: IVVerificationUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusId = _data["statusId"];
            this.farmName = _data["farmName"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.countyId = _data["countyId"];
        }
    }

    static fromJS(data: any): VVerificationUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusId"] = this.statusId;
        data["farmName"] = this.farmName;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["countyId"] = this.countyId;
        return data; 
    }

    clone(): VVerificationUpdateDto {
        const json = this.toJSON();
        let result = new VVerificationUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationUpdateDto {
    id: number;
    statusId: VVerificationStatusEnum;
    farmName: string | undefined;
    longitude: number | undefined;
    latitude: number | undefined;
    countyId: number | undefined;
}

export class VVerificationCreateDto implements IVVerificationCreateDto {
    farmName: string | undefined;
    longitude: number | undefined;
    latitude: number | undefined;
    countyId: number | undefined;

    constructor(data?: IVVerificationCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farmName = _data["farmName"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.countyId = _data["countyId"];
        }
    }

    static fromJS(data: any): VVerificationCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VVerificationCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmName"] = this.farmName;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["countyId"] = this.countyId;
        return data; 
    }

    clone(): VVerificationCreateDto {
        const json = this.toJSON();
        let result = new VVerificationCreateDto();
        result.init(json);
        return result;
    }
}

export interface IVVerificationCreateDto {
    farmName: string | undefined;
    longitude: number | undefined;
    latitude: number | undefined;
    countyId: number | undefined;
}

export class WatershedDto implements IWatershedDto {
    name: string | undefined;
    code: string | undefined;
    id: number;

    constructor(data?: IWatershedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WatershedDto {
        data = typeof data === 'object' ? data : {};
        let result = new WatershedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data; 
    }

    clone(): WatershedDto {
        const json = this.toJSON();
        let result = new WatershedDto();
        result.init(json);
        return result;
    }
}

export interface IWatershedDto {
    name: string | undefined;
    code: string | undefined;
    id: number;
}

export class Answers implements IAnswers {
    owned: CAnswerDto[];
    rented: CAnswerDto[];

    constructor(data?: IAnswers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Owned"])) {
                this.owned = [] as any;
                for (let item of _data["Owned"])
                    this.owned.push(CAnswerDto.fromJS(item));
            }
            if (Array.isArray(_data["Rented"])) {
                this.rented = [] as any;
                for (let item of _data["Rented"])
                    this.rented.push(CAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Answers {
        data = typeof data === 'object' ? data : {};
        let result = new Answers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.owned)) {
            data["Owned"] = [];
            for (let item of this.owned)
                data["Owned"].push(item.toJSON());
        }
        if (Array.isArray(this.rented)) {
            data["Rented"] = [];
            for (let item of this.rented)
                data["Rented"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Answers {
        const json = this.toJSON();
        let result = new Answers();
        result.init(json);
        return result;
    }
}

export interface IAnswers {
    owned: CAnswerDto[];
    rented: CAnswerDto[];
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}